import { GoogleAnalyticsService } from './../../google-analytics.service';
import {
   Component,
   OnInit,
   Output,
   ViewChild,
   EventEmitter,
   ComponentRef,
   ComponentFactoryResolver, ViewContainerRef, ElementRef, Renderer2, HostListener, ChangeDetectorRef, OnDestroy
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {UploadDocumentComponent} from '../tasks/upload-document/upload-document.component';
import {MailFlowComponent} from '../mail-flow/mail-flow.component';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatStepper } from '@angular/material/stepper';
import {IdexService} from 'app/idex.service';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from 'app/shared/toast/toast';
import {CreateTaskSignOffComponent, Itemrotate} from '../sign-off/create-task-sign-off/create-task-sign-off.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Mimetype} from '../../shared/mimetype';
import {PdfRenditionWatcher} from '../../shared/pdf-rendition-watcher';
import {MomentPipe} from '../../shared/moment.pipe';
import {DocTypeComponent} from '../../shared/doctype.component';
import {ThumbnailComponent} from '../sign-document/thumbnail/thumbnail.component';
import {DeleteDialogComponent} from '../delete-dialog/delete-dialog.component';
import {DeleteCommentComponent} from '../../dms/delete-comment/delete-comment.component';
import {DomSanitizer} from '@angular/platform-browser';
import {ConfirmRemovesignDialogComponent} from '../confirm-removesign-dialog/confirm-removesign-dialog.component';
import {Observable, Subject} from 'rxjs';
import {PackageDialogComponent} from './../tasks/package-dialog/package-dialog.component';
import {combineAll} from 'rxjs/operators';
import {Section} from '../../e-form/model/eform-type';
import {EformAPI} from '../../e-form/e-form.api';
import {EformService} from 'app/e-form/service/eform.service';
import { DataService } from 'app/data.service';
import { TaskAttribute } from './create-task.type';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

declare var $: any;

export interface Itemrotate2 {
   scale: number;
   posx: number;
   posy: number;
   transformHeight: number;
   width: number;
   height: number;
}

export interface ImageData {
   itemImgThumbnail: ItemImageThumbnail[];
   lastPageLoaded: number;
   thumbnailSelect: any[];
}

export interface ItemImageThumbnail {
   docId: string;
   pageNo: number;
   isLoad: boolean;
}

@Component({
   selector: 'app-create-task',
   templateUrl: './create-task.component.html',
   styleUrls: ['./create-task.component.css']
})

export class CreateTaskComponent implements OnInit, OnDestroy {
   @Output() selectionChange: EventEmitter<StepperSelectionEvent>;
   @Output() animationDone: EventEmitter<BrowserAnimationsModule>;
   @ViewChild(UploadDocumentComponent, { static: true }) public uploadComp: UploadDocumentComponent;
   @ViewChild(MailFlowComponent, { static: true }) public mailFlowComp: MailFlowComponent;
   @ViewChild(CreateTaskSignOffComponent, { static: true }) public createTaskSignOffComp: CreateTaskSignOffComponent;
   @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
   @ViewChild(ThumbnailComponent) public ThumbnailComp: ThumbnailComponent;
   @ViewChild('content') con: ElementRef;
   @ViewChild('fileUpload') fileUpload: ElementRef;
   @ViewChild('info') info: ElementRef;
   @ViewChild('form1', {read: ViewContainerRef}) form1: ViewContainerRef;
   @ViewChild('form2', {read: ViewContainerRef}) form2: ViewContainerRef;
   @ViewChild('imgThumbnail') imgThumbnail: ElementRef;
   @ViewChild('btnBack') btnBack: MatButton;
   @ViewChild('btnCancel') btnCancel: MatButton;
   @ViewChild('btnSave') btnSave: MatButton;
   @ViewChild('btnSend') btnSend: MatButton;
   @ViewChild(CreateTaskSignOffComponent) signOffComponent!: CreateTaskSignOffComponent;
   ignoreSelectionChange = false;
   firstTimeLoaded = true;
   private _actionNeedToSign = 'Need to Sign';
   private _actionExternalSign = 'External Sign';
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   private _initial = false;
   private dpi = 20;
   private _isShowTutorial: any;
   private param;
   private id: number;
   private templateInfo: any;
   private signatureLength: number;
   public signerData: any = [];
   public isToggleLeftOpened = true;
   public typeNames: any;
   public isToggleRightOpened = true;
   public flowRecipient: any;
   public messageRecipient;
   public maxPage: any;
   public selectedTab = 1;
   public selectButton = false;
   public dataWidthHeight: any;
   public isDeleteDocument = false;
   public thumbnailSelectedDel = [];
   public indexSelect;
   public dataWidthHeightAll: any;
   public thumbnailSelected = [];
   public selectDelItems: any[] = [];
   public checkselectedItems: any = [];
   public selectedItems: any = [];
   public maxIndex: number;
   public imgThumbnails: ImageData[] = [];
   /** เลิกรับผลการแปลงจาก watcher ของ createTaskSignOffComp (thumbnail ไม่ poll เอง) */
   private unsubscribeThumbnailReady: () => void;
   public totalPages: any;
   public header;
   public nameSite: string;
   public certificateHeader;
   public backpage;
   public isDesktop = true;
   public user_emails = this.service.user.email;
   public colors = [
      '#8b0000',
      '#daa520',
      '#778899',
      '#800080',
      '#ff00ff',
      '#008080',
      '#556b2f',
      '#32cd32',
      '#3EA99F',
      '#0000cd',
      '#ff69b4',
      '#ff0000',
      '#bdb76b',
      '#FFD700',
      '#7FFFD4',
      '#FF4500',
      '#32CD32',
      '#FF8B8B',
      '#9932CC',
      '#A0522D',
      '#00CED1',
      '#2F4F4F',
      '#98AFC7',
      '#566D7E',
      '#FBE7A1',
      '#728FCE',
      '#4863A0',
      '#2B547E',
      '#81D8D0',
      '#2554C7',
      '#1589FF',
      '#00BFFF',
      '#87CEEB',
      '#C6DEFF',
      '#B0E0E6',
      '#16E2F5',
      '#045F5F',
      '#31906E',
      '#50C878',
      '#006400',
      '#32CD32',
      '#DAEE01',
      '#FFFACD',
      '#57FEFF',
      '#FED8B1',
      '#FFFF00',
      '#D9F1F1',
      '#B6E3E9',
      '#D1EAF5',
      '#C3DDE0',
      '#A5CEDB',
      '#95C8D7',
      '#AACCE2',
      '#789CCE',
      '#FBD4AD',
      '#F8D7C1',
      '#EDAB94',
      '#FFAE92',
      '#DADDC5',
      '#A5B89C',
      '#C1D7D0',
      '#CAE3CC',
      '#E0F8E8',
      '#D9EDE7',
      '#BDDED1',
      '#B7B7FF',
      '#E7D2EF',
      '#EFE5EE',
      '#C4B3C3',
      '#C6A5C7',
      '#E2D0DC',
      '#D9B0CD',
      '#DFA5D6',
      '#E5A9DE',
      '#FEF4F3',
      '#FCDEE2',
      '#FFD6DA',
      '#FFC6CF',
      '#FFE4E3',
      '#FFD3D3',
      '#FFCDCD',
      '#FFB7B7',
      '#FBF1D5',
      '#FFE2AE',
      '#F4CC84',
      '#F7D07A'
   ];
   public taskAttribute: TaskAttribute = {
      taskId: 0,
      taskName: '',
      dueDate: null,
      priority: 0,
      templateId: 0,
      workflowId: 0,
      workflowIdSelect: 0,
      currentLevel: 1,
      apvLevel: [],
      workflowName: '',
      templateName: '',
      docList: [],
      message: '',
      idFolderExport: '',
      exportStatus: '',
      exportPath: '',
      siteId: '',
      certCode: '',
      formName: '',
      dayLeft: null,
      retentionPeriod: -1,
      formList : {
         alfFormId: '',
         alfVersions: '',
         createdBy: '',
         createdDate: '',
         formCode: '',
         formId: 0,
         formName: '',
         formType: '',
         isActive: true,
         isDeleted: false,
         original: '',
         tin: '',
         updateBy: '',
         updateDate: '',
         versions: ''
      },
      tempId: null,
      haveApvLevel: false,
      typeName: '',
      isFormStartFlow: false
   };
   public isThumbnailLoadFinish = false;
   public isOnDownloadDoc = false;
   public trash = false;
   public disableButtonSign = true;
   public pageType: string;
   public getDoc = [];
   public isDocList: boolean;
   public setDisableCompleteTask = false;
   public link: string;
   public idFolderExport: string;
   public dataFormName;
   isShowAttachFile = false;
   dataPage: any;
   checkloaded = true;
   mode: string;
   sender: any;
   scroll: any;
   loadedBypage: any = [];
   statechange = false;
   flagrotateall: any = false;
   shiftPressed = false;
   flagupload = false;
   email: any;
   flagCheckSelectInsert = true;
   isSender: boolean;
   saveText: string;
   errorMessage: any;
   isLinear = true;
   taskId: number;
   post = 'ส่ง';
   doc: any;
   form: any;
   docId: any;
   show: boolean;
   description: any;
   sendWidthHeighttt2: any = [];
   sendWidthHeighttt: any;
   itemRotate: Itemrotate = {} as any;
   comment: any;
   isAddMetadata = true;
   flagCheckSelect = false;
   settype = false;
   types: any[];
   tabBar: boolean;
   data = {
      item: undefined,
      taskId: 0,
      mode: undefined,
      typeName: undefined,
      isResend: false,
   };
   firstFormGroup: FormGroup;
   secondFormGroup: FormGroup;
   thirdFormGroup: FormGroup;
   lastModified: any;
   selectedValue: any;
   selectedValue1: any;
   checkErrorRecipient: boolean;
   checkErrorSelectRecipient: boolean;
   checkErrorUploadNotFinish: boolean;
   isCompleteTask = false;
   versionDoc: any;
   checkPDF: boolean;
   public sections: Section[];
   private chunkSize = 1048576;
   private viewPackage: MatDialogRef<PackageDialogComponent>;
   autoApprove = false;
   share = false;
   viewMode = false;
   public certificateOrgList: any[] = [];
   firstSignField: any;
   haveSignField: boolean = false;
   saveInProgress = false;
   isShowDownloadAll: boolean = true;
   fileFormName = '';
   alreadySign = true;
   safeToExit$: Subject<boolean>;
   unsaveTemplate$: Subject<string>;

   constructor(private _formBuilder: FormBuilder,
               public service: IdexService,
               public translate: TranslateService,
               public toast: Toast,
               private route: ActivatedRoute,
               private renderer: Renderer2,
               private sanitizer: DomSanitizer,
               private router: Router, private resolver: ComponentFactoryResolver,
               private dialog: MatDialog,
               private api: EformAPI,
               private eFormService: EformService,
               private cdref: ChangeDetectorRef,
               private googleAnalyticsService:GoogleAnalyticsService,
               private dataService: DataService
            ) {

      this.translate.get('create_tasks.save').subscribe(s => {
         this.saveText = s;
      });
      this.service.loadFileMaxUpload();
      this.isDesktop = this.checkDevice();
      if (this.router.url.indexOf('create-task') !== -1) { // ตรวจสอบว่าเป็นหน้าที่มาจากการสร้าง task
         this.pageType = 'task'; // ตั้งค่าเริ่มต้นที่ใช้ในการแบ่งหน้าว่าเป็น createTask, template ในการทำงานแยกการทำงานแต่ละส่วนใน on step change
         this.typeNames = 'task'; // ตั้งค่าเริ่มต้นที่ใช้ในการแบ่งหน้าว่าเป็น createTask, template ในการเรียกของหน้า UI
         this.route.queryParams.subscribe(params => { // ดึง data จาก url params มา
            if (params['siteId']) {
               this.taskAttribute.siteId = params['siteId'];
            }
            if (params['data']) { // ดึง data ตัวแปรที่ชื่อว่า data มาตรวจสอบว่ามีค่าหรือไม่
               this.data = JSON.parse(params['data']); // ดึง data มาเก็บไว้ที่ตัวแปรนี้
               if (this.data.typeName !== undefined) {
                  this.typeNames = this.data.typeName;
               }
               this.taskId = this.data.taskId; // ตั้งค่า taskId ให้กับตัวแปรนี้
               this.mode = this.data.mode; // ตั้งค่า mode ที่ใช้ในการแบ่งหน้าว่าเป็น draft หรือไม่
               if (this.data.item.tempId){
                  this.taskAttribute.tempId = atob(this.data.item.tempId);
               }
               if (this.data.typeName) {
                  this.taskAttribute.typeName = this.data.typeName;
               }
               if (this.taskId !== undefined) {
                  this.service.deleteDocList(this.taskId)
                     .subscribe((item) => {
                           this.service.getTask(this.taskId, true).subscribe((data) => {
                                 if (data) {
                                    data.templateName = '';
                                    data.workflowName = '';
                                    if (data.rejectReason !== undefined ) {
                                       this.isShowAttachFile = true;
                                    }
                                    if (data.templateId !== undefined) { // เช็ค Template
                                       this.id = data.templateId;
                                       this.getTemplate();
                                    }
                                    if (data.docList.length === 0) {
                                       this.translate.get('create_tasks.deleted').subscribe(s => this.toast.error(s.toString()));
                                    }
                                    this.taskAttribute = data;
                                    this.eFormService.taskAttributeTemp = data;

                                    if (this.taskAttribute.siteId !== undefined){ // set siteId in upload
                                       this.uploadComp.taskAttribute.siteId = data.siteId;
                                       this.uploadComp.selectSiteName = {name: this.uploadComp.getSiteList(data.siteId), tin: data.siteId};
                                       this.uploadComp.myControlSite.setValue({name: this.uploadComp.getSiteList(data.siteId), tin: data.siteId});
                                       this.uploadComp.changeSelectSite();
                                    }

                                    if(data.apvLevel){
                                       this.taskAttribute.haveApvLevel = true;
                                    }
                                    if(data.dueDate) { // เช็ค Task date delete
                                       this.uploadComp.isSignDate = true;
                                       let date = data.dueDate.split('-');
                                       let mydate = new Date();
                                       mydate.setFullYear(+date[2], +date[1]-1, +date[0]); // เดือนลบ 1 เพราะ Date.setFullYear นับเดือนเริ่มจาก 0 ถึง 11
                                       let createdDate = data.createDate.split(' ');//แยกเวลาออกจากวัน
                                       createdDate = createdDate[0].split('-');
                                       let createDate = new Date();
                                       createDate.setFullYear(+createdDate[0], +createdDate[1]-1, +createdDate[2]);
                                       let nowDate = new Date();
                                       this.uploadComp.currentDate = nowDate;
                                       this.uploadComp.dateEnd = mydate;
                                       this.taskAttribute.dueDate = mydate;
                                       if(mydate.getTime() >= nowDate.getTime()){ //เช็คเวลาที่หมดอายุมากกว่าถึงจะ set date หมดอายุ
                                          if (mydate.toDateString() === nowDate.toDateString()) {//กรณีเลือกวันนี้ปัดวันอยู่แล้วเลยไม่ต้อง +1
                                             this.uploadComp.dayLeft = 1;
                                          }else {
                                             this.uploadComp.dayLeft = Math.ceil((mydate.getTime() - nowDate.getTime()) / (1000 * 3600 * 24)) + 1;
                                          }
                                       } else {
                                          this.uploadComp.dayLeft = null;
                                          this.uploadComp.errorPeriod = true;
                                          this.handleToastError('due-date.invalidSignDate');
                                       }
                                    }
                                    if(data.retentionPeriod >= 0 && data.retentionPeriod !== null) { //เช็ค Date delete doc หลังเซ็น
                                       this.uploadComp.isEndDate = true;
                                       this.uploadComp.deletDayleft = data.retentionPeriod;
                                    }
                                    for (let i = 0; i < this.taskAttribute.docList.length; i++) {
                                       if (this.taskAttribute.docList[0].isAttachFile) {
                                          this.taskAttribute.docList.push(this.taskAttribute.docList[0]);
                                          this.taskAttribute.docList.splice(0, 1);
                                       } else {
                                          break;
                                       }
                                    }
                                    if (this.taskAttribute.docList.length > 0) {
                                       for(let i = 0; i < this.taskAttribute.docList.length; i++) {
                                          if (this.taskAttribute.docList[i].docName) {
                                             const doc = this.taskAttribute.docList[i];
                                             var ext = doc.docName.split('.').pop();
                                             if (ext.toLowerCase() === 'zdox') {
                                                this.taskAttribute.formList = {
                                                   formName : doc.docName,
                                                   createdDate : doc.createdDate,
                                                   createdBy : doc.createdBy,
                                                   updateDate : doc.updateDate,
                                                   updateBy : doc.updateBy,
                                                   versions : doc.version,
                                                   alfFormId: '',
                                                   alfVersions: '',
                                                   formCode: '',
                                                   formId: 0,
                                                   formType: '',
                                                   isActive: true,
                                                   isDeleted: false,
                                                   original: '',
                                                   tin: '',
                                                }
                                                this.taskAttribute.formName = this.taskAttribute.docList[i].docName;
                                                this.fileFormName = this.taskAttribute.formName;
                                                this.taskAttribute.docList[i].isForm = true;
                                                this.taskAttribute.isFormStartFlow = true;
                                                this.getEFormFormDocId(doc.docId)
                                                break;
                                             }
                                          }
                                       }
                                    }
                                    this.uploadComp.getMimetype(this.taskAttribute.docList);
                                    if (this.taskAttribute.exportStatus !== 'N') { // ถ้าไม่เป็นสถานะ N จะมีการตั้งค่า initial export path
                                       this.idFolderExport = this.taskAttribute.idFolderExport;
                                       this.uploadComp.exportOption = this.taskAttribute.exportStatus;
                                       this.uploadComp.idFolderExport = this.idFolderExport;
                                       this.uploadComp.link = this.taskAttribute.exportPath;
                                       this.uploadComp.isExport = true;

                                       let isHaveDocList = false;
                                       const haveDocList = this.taskAttribute.docList.filter(docs => docs.isDocList === true);
                                       if (haveDocList && haveDocList.length > 0) {
                                          isHaveDocList = true;
                                       }
                                       this.uploadComp.isDocList = isHaveDocList;
                                       if (this.data.isResend) { // ถ้าเป็นการ resend ต้องมีการตั้งค่าระบุไว้เพื่อจะได้รู้ว่าเป็นการ resend
                                          this.uploadComp.isResend = true;
                                          if (this.uploadComp.exportOption !== 'E') {
                                             this.uploadComp.isExportPathChange = true;
                                          } else {
                                             this.uploadComp.isExportPathChange = false;
                                          }
                                       }
                                    }
                                    if (this.taskAttribute.docList.length > 0) {
                                       this.service.getCompleteTask(this.taskAttribute.docList[0].docId).subscribe((data1) => {
                                          if (data1 > 0) {
                                             this.isCompleteTask = true;
                                          } else {
                                             this.isCompleteTask = false;
                                          }
                                          this.setDisableCompleteTask = this.isCompleteTask; // ตั้งค่าเอาไว้ disable , hide ปุ่มต่างๆในหน้า UI
                                       });
                                    }
                                    if (this.taskAttribute.templateId) { // ถ้า createTask ด้วยการเลือก template ไว้จะมีค่าของ templateId ตามมา
                                       this.service.getTemplate(this.taskAttribute.templateId, true)
                                          .subscribe((data2) => {
                                                if (!this.taskId) {
                                                   this.taskAttribute.apvLevel = data2.apvLevel; // ตั้งค่า flow ตาม template
                                                   this.uploadComp.setSignItems(data2); // ตั้งค่าตำแหน่ง signItem ตาม template
                                                }
                                                this.uploadComp.selectSiteName = {
                                                   name: this.uploadComp.getSiteList(data2.siteId),
                                                   tin: data2.siteId
                                                };
                                                this.uploadComp.myControlSite.setValue({
                                                   name: this.uploadComp.getSiteList(data2.siteId),
                                                   tin: data2.siteId
                                                });
                                                this.uploadComp.changeSelectSite();
                                             },
                                             (err) => {
                                                console.error(err);
                                             })
                                          .add(() => {
                                             this.handleWaitActionLoadPreview(false);
                                          });

                                    }
                                    if(this.taskAttribute.certCode && this.taskAttribute.siteId){
                                       this.uploadComp.setCertificateHeader(this.taskAttribute.certCode);
                                       this.uploadComp.setSitewithCertificateTask(this.taskAttribute.siteId);
                                       this.uploadComp.setTaskNameHeader(this.taskAttribute.siteId);
                                       this.uploadComp.selectSiteName = {name: this.uploadComp.getSiteList(this.taskAttribute.siteId), tin: this.taskAttribute.siteId};
                                       this.uploadComp.myControlSite.setValue({name: this.uploadComp.getSiteList(this.taskAttribute.siteId), tin: this.taskAttribute.siteId});
                                       this.uploadComp.changeSelectSite();
                                    }
                                 }
                              },
                              err => {
                                 this.toast.error(err);
                              })
                              .add(() => {
                                 this.handleWaitActionLoadPreview(false);
                              });
                        },
                        err => {
                           this.toast.error(err);
                        })
                     .add(() => {
                        this.handleWaitActionLoadPreview(false);
                     });
               } else {
                  this.getCertificate(); // ดึงค่า Certificate
                  if (this.data.item.id !== undefined) { // กรณีที่ไม่มี taskId จะถือว่าเป็น complete task ถ้ามี item ที่มี id อยู่แต่ถ้าไม่ก็เป็น new task
                     this.service.getCompleteTask(this.data.item.id).subscribe((data) => {
                        if (data > 0) {
                           this.isCompleteTask = true;
                        } else {
                           this.isCompleteTask = false;
                        }
                        this.setDisableCompleteTask = this.isCompleteTask;
                        if(this.typeNames === 'startFlow'){
                           this.uploadComp.setTaskNameHeader(this.taskAttribute.siteId);
                           this.uploadComp.taskAttribute.siteId = this.taskAttribute.siteId;
                           this.uploadComp.selectSiteName = {name: this.uploadComp.getSiteList(this.taskAttribute.siteId), tin: this.taskAttribute.siteId};
                           this.uploadComp.myControlSite.setValue({name: this.uploadComp.getSiteList(this.taskAttribute.siteId), tin: this.taskAttribute.siteId});
                           if(this.taskAttribute.siteId === 'My Files')
                           {
                              this.uploadComp.filterSiteChanger();
                           }

                           this.uploadComp.changeSelectSite();// Set Site when startflow
                           this.uploadComp.myControlSelectSite.disable(); // เพิ่ม Disable ไม่ให้สามารถเลือกได้กรณีเลือกผ่าน dms
                           let ischeck = false;
                           if(this.certificateOrgList !== null){ // ตรวจสอบว่าได้ติดตั้ง Certificate ให้กับ Site หรือยัง
                              if(this.certificateOrgList.length > 0){
                                 for(let i = 0; i < this.certificateOrgList.length; i++){
                                    if(this.certificateOrgList[i].certType === "ORG"){
                                       if(this.taskAttribute.siteId===this.certificateOrgList[i].objectName){
                                          ischeck = true;
                                       }
                                    }
                                 }
                              }
                           }
                           if(ischeck === true){ // กรณี site มี certificate
                              this.uploadComp.checkcertList = "2";
                              this.uploadComp.cerOrgDesc.nativeElement.style.visibility = "hidden"; // ซ่อนข้อความ ติดตั้ง certificate
                              this.uploadComp.ischeckCertOrg = true;
                              this.uploadComp.ischeckCertPer = false;
                              this.uploadComp.cerType.nativeElement.style.display = '';
                              this.uploadComp.setCertificateHeader("STCA"); // set Organizecert ที่หัว Header
                              this.uploadComp.cerOrgDes.nativeElement.disabled = false; //disabled ปุ่มออก
                              this.uploadComp.cerOrgDesc.nativeElement.disabled = false; //disabled ปุ่มออก
                              this.uploadComp.cerOrgDes.nativeElement.style.color = '#000000'; //ปรับสี Description ให้เป็นสีเดิม
                              this.uploadComp.cerOrgDesc.nativeElement.style.color = '#000000'; //ปรับสี Description ให้เป็นสีเดิม
                              this.uploadComp.cerOrg.disabled = false; // enable ปุ่มห้ามกดกรณีมี cert
                           }
                           if(ischeck === false){ // กรณี site ไม่มี certificate
                              this.uploadComp.checkcertList = "1";
                              this.uploadComp.ischeckCertOrg = false;
                              this.uploadComp.ischeckCertPer = false;
                              this.uploadComp.cerOrgDesc.nativeElement.style.visibility = "visible"; // ซ่อนข้อความ ติดตั้ง certificate
                              this.uploadComp.setCertificateHeader("ZDOX"); // set zDox ที่หัว Header
                              this.uploadComp.cerType.nativeElement.style.display = 'none';
                              this.uploadComp.cerOrgDes.nativeElement.disabled = true; //disabled ปุ่ม
                              this.uploadComp.cerOrgDesc.nativeElement.disabled = true; //disabled ปุ่ม
                              this.uploadComp.cerOrgDes.nativeElement.style.color = '#555'; //ปรับสี Description ให้เป็นสีจาง
                              this.uploadComp.cerOrgDesc.nativeElement.style.color = '#555'; //ปรับสี Description ให้เป็นสีจาง
                              this.uploadComp.cerOrg.disabled = true; // disabled ปุ่มห้ามกดกรณีไม่มี cert
                           }
                        }
                     })
                     .add(() => {
                        this.handleWaitActionLoadPreview(false);
                     });
                  }
               }
            }
         })
         .add(() => {
            this.handleWaitActionLoadPreview(false);
         });
      } else { // กรณีหน้า Template
         this.pageType = 'template'; // ตั้งค่าเริ่มต้นที่ใช้ในการแบ่งหน้าว่าเป็น createTask, template ในการทำงานแยกการทำงานแต่ละส่วนใน on step change
         this.typeNames = 'template'; // ตั้งค่าเริ่มต้นที่ใช้ในการแบ่งหน้าว่าเป็น createTask, template ในการเรียกของหน้า UI
         this.route.queryParams.subscribe(params => {
            if (params['p']) {
               this.param = JSON.parse(params['p']);
               this.mode = this.param.mode;
               this.id = this.param.id;
               this.autoApprove = this.param.auto === 't';
               this.share = this.param.share === 't';
               this.viewMode = this.param.viewMode;
            }

         })
            .add(() => {
               this.handleWaitActionLoadPreview(false);
            });
      }
   }

   ngOnInit() {
      this.handleWaitActionLoadPreview(true);
      if (this.typeNames !== 'startFlow') { // กรณีไม่ได้มาจากการ start flow จากหน้า document management ให้ตั้งค่าเริ่มต้นให้ docList
         if (this.taskAttribute !== undefined) {
            if (this.taskAttribute.docList.length > 0) {
               this.uploadComp.isDocList = this.taskAttribute.docList[0].isDocList; // ระบุว่าเป็นการเปิดมาจากหน้า document management
            }
         }
      } else {
         this.link = localStorage.getItem('paths') + '/'; // ดึงค่า path เพื่อตั้งให้ export path กรณีที่ start flow มาจาก document management
         this.idFolderExport = localStorage.getItem('folderId'); // ดึงค่า folder id มา เพื่อตั้ง folder id ให้เพื่อส่งไปที่ service create task
         this.uploadComp.isExport = true; // ตั้งค่าระบุว่ามีการ export เพราะ start flow มาจาก หน้า document management
         this.uploadComp.exportOption = 'E'; // ตั้งค่าเริ่มต้น option ให้เป็น export ในหน้า createTask
      }
      this.firstFormGroup = this._formBuilder.group({
         // firstCtrl: ['', Validators.required]
      });

      this.secondFormGroup = this._formBuilder.group({
         // secondCtrl: ['', Validators.required]
      });
      this.thirdFormGroup = this._formBuilder.group({
         type_val: new FormControl()
         // thirdCtrl: ['', Validators.required]
      });
      if (this.pageType === 'task') { // กรณีเป็นหน้า task

         if (this.data.taskId === 0) {
            this.handleWaitActionLoadPreview(false);
         }
         this.translate.get('newTask.fieldTypeName').subscribe((msg) => { // ตั้งค่า message ต่างๆให้ตรงตามภาษาที่เลือกไว้
            this.uploadComp.fieldTypeName = msg; // fieldTypeName
         });
         if (this.data.typeName !== 'startFlow') {
            this.translate.get('taskList.newTask').subscribe((msg) => {
               this.header = msg;
               this.nameSite;
            });
         } else {
            this.translate.get('taskList.startFlow').subscribe((msg) => {
               this.header = msg;
               this.nameSite;
            });
         }
         this.uploadComp.isTask = true; // ระบุในการ upload ว่าเป็น task
         this.flowRecipient = this.mailFlowComp.flowRecipient; // ตั้งค่าเริ่มต้นให้ flowRecipient ในหน้า step วาง flow email
         this.messageRecipient = this.mailFlowComp.messageRecipient; // ตั้งค่าเริ่มต้นให้ messageRecipient ในหน้า step วาง flow email
         if (this.data.typeName) { // ถ้ามีการระบุ TypeName ให้ตั้งค่า TypeName ใน component signoff  จะได้รู้ว่ามาจากการ startflow หรือ create ปกติ
            this.createTaskSignOffComp.typeName = this.data.typeName;
         }

         if (this.data.item) { // กรณี draft ที่มีการวางลายเซ็นต์ลงไว้แล้วจะต้องตั้งค่าเริ่มต้นตามลายเซ็นต์ใน task นั้นๆเมื่อเปิด
            this.createTaskSignOffComp.item = this.data.item;
         }

         if (this.data.typeName === 'startFlow') {
            this.createTaskSignOffComp.siteId = this.taskAttribute.siteId
            this.createTaskSignOffComp.type = this.data.typeName;
            this.service.getDocument(this.data.item.id)
               .subscribe(data => {
                  this.versionDoc = data.version;
               }, error => {
                  // This is intentional.
               })
               .add(() => {
                  this.handleWaitActionLoadPreview(false);
               });
         }
      } else { // template
         this.translate.get('newTemplate.fieldTypeName').subscribe((msg) => {
            this.uploadComp.fieldTypeName = msg; // fieldTypeName
         });
         if (this.share) {
            this.translate.get('template.share').subscribe((msg) => {
               this.header = msg;
               this.nameSite;
            });
            this.translate.get('return').subscribe((msg) => {
               this.backpage = msg;
            });
         } else {
            this.translate.get('template.new').subscribe((msg) => {
               this.header = msg;
               this.nameSite;
            });
         }
         this.uploadComp.isTask = false; // ระบุว่าไม่ได้เป็น task
         this.flowRecipient = this.mailFlowComp.flowRecipient;
         this.messageRecipient = this.mailFlowComp.messageRecipient;

         let headTitle = 'template.new';
         if (this.mode === 'edit') {
            headTitle = 'template.title';
         }

         this.translate.get(headTitle).subscribe(s => {
            this.header = s;
            this.nameSite;
         });

         this.createTaskSignOffComp.isHideCommentPdf = true; // ซ่อนปุ่ม comment pdf
         this.getTemplate();
      }
      this.cdref.detectChanges();
   }

   flagloadrotate($event) {
      this.flagrotateall = $event;
      setTimeout(() => {
         this.flagrotateall = false;
      }, 800);
   }

   @HostListener('scroll', ['$event'])
   scrollHandler(event) {
      // This is intentional.
   }

   uploadChangeStep1() {
      this.checkErrorUploadNotFinish = false;

      // Check if there's already a Template selected or not.
      //
      // If there's a Template, but the variable 'nameSite' is still undefined,
      // update nameSite to store the current Template.
      if(this.uploadComp?.siteNameList?.nativeElement?.value && this.nameSite === undefined) {
         this.onSetNameTask(this.uploadComp.siteNameList.nativeElement.value);
      }

      let isCheck = false;
      this.taskAttribute.docList.forEach(doc => {
         const extensions = doc.docName.split('.').pop().toLowerCase();
         if (doc.isForm || extensions === 'zdox') {
            isCheck = true;
         } else if (extensions === 'pdf') {
            isCheck = true;
         }
      });
      const namesite = this.nameSite ? this.nameSite.substring(3) : this.nameSite;
      if (this.pageType === 'task' || this.pageType === 'template') {
         // If the user clicks the template and select a new template OR
         // if a template is already selected beforehands.
         if (this.uploadComp.selectTemplate === true || this.uploadComp.templatesList) {
            if (this.taskAttribute.taskName === '' || this.taskAttribute.taskName === undefined) {
               this.handleToastError('newTask.errorInputTaskName');
               return false;
            } else if (this.taskAttribute.docList.length === 0) {
               this.handleToastError('newTask.errorSelectFile');
               return false;
            } else if (this.uploadComp.selectSiteName.name === '' || this.uploadComp.selectSiteName.name === undefined) {
               this.handleToastError('newTask.errorSelectSite');
               return false;
            } else if (this.uploadComp.selectSiteName.name !== namesite) {
                  this.handleToastError('newTask.errorSiteCompat');
                  return false;
            } else if(this.uploadComp.checkcertList === '2'){
               if(this.uploadComp.cerOrg.checked === false && this.uploadComp.cerPer.checked === false){
                  this.handleToastError('newTask.errorSelectSealType');
                  return false;
               }
            } else if (this.uploadComp.object_file !== null
               && this.uploadComp.object_file !== undefined
               && this.uploadComp.object_file.length > 0) {
               this.handleToastError('newTask.errorUploadFileNotFinish');
               return false;
            } else if (this.uploadComp.isExport) {
               if (this.typeNames !== 'startFlow') {
                  if (!this.uploadComp.link) {
                     this.handleToastError('newTask.errorSelectExportPath');
                     return false;
                  }
               }
            } else if (this.taskAttribute.formName) {
               this.api.checkedFormName(this.taskAttribute.formName,"","")
                  .subscribe(data => {
                     if (data.content.length === 0) {
                        return false;
                        this.handleToastError('newTask.errorFormName');
                     } else {
                        return true;
                     }
                  });
            } else if (this.taskAttribute.docList.length) {
               if (!isCheck) {
                  this.handleToastError('newTask.errorSelectOnceOfFile');
                  return false;
               }
            }
            /**
             * check input data and notify when fill in the letters  < > \ / : ? * ' | % ^ { } [ ]
             *
             */
            if (/[<|>\\\/:?*"%^{}[\]]/g.test(this.taskAttribute.taskName)) {
               this.handleToastError('alert.create_folder_errors_full');
               return false;
            } else if (this.uploadComp.errorPeriod === true && this.uploadComp.isSignDate){
               this.handleToastError('due-date.invalidSignDate');
               return false;
            } else if (this.uploadComp.errorSignDate === true){
               this.handleToastError('due-date.errorSignDate');
               return false;
            } else if (this.uploadComp.errorDocDate === true){
               this.handleToastError('due-date.errorDocDate');
               return false;
            } else {
               this.checkErrorUploadNotFinish = true;
            }
         } else if (this.uploadComp.errorPeriod === true && this.uploadComp.isSignDate){
            this.handleToastError('due-date.invalidSignDate');
            return false;
         } else if (this.uploadComp.errorSignDate === true){
            this.handleToastError('due-date.errorSignDate');
            return false;
         } else if (this.uploadComp.errorDocDate === true){
            this.handleToastError('due-date.errorDocDate');
            return false;
         } else {
            this.handleToastError('newTask.errorSelectTemplate');
            return false;
         }
      } else { // template
         if (this.taskAttribute.taskName === '' || this.taskAttribute.taskName === undefined) {
            this.handleToastError('newTemplate.errorInputTemplateName');
            return false;
         } else
         /**
          * check input data and notify when fill in the letters  < > \ / : ? * ' | % ^ { } [ ]
          *
          */
         if (/[<|>\\\/:?*"%^{}[\]]/g.test(this.taskAttribute.taskName)) {

            this.handleToastError('alert.create_folder_errors_full');
            return false;
         } else if (this.taskAttribute.docList) { // ถ้าไม่มีการ upload document
            if (this.taskAttribute.docList.length === 0) {
               this.handleToastError('newTemplate.errorSelectFile');
               return false;
            }
         } else if (this.uploadComp.object_file !== null && this.uploadComp.object_file !== undefined
            && this.uploadComp.object_file.length > 0) { //
            this.handleToastError('newTemplate.errorUploadFileNotFinish');
            return false;
         } else if (this.uploadComp.errorPeriod === true && this.uploadComp.isSignDate){
            this.handleToastError('due-date.invalidSignDate');
            return false;
         } else if (this.uploadComp.errorSignDate === true){
            this.handleToastError('due-date.errorSignDate');
            return false;
         } else if (this.uploadComp.errorDocDate === true){
            this.handleToastError('due-date.errorDocDate');
            return false;
         } else if (this.uploadComp.selectSiteName.name === '' || this.uploadComp.selectSiteName.name === undefined) {
            this.handleToastError('newTask.errorSelectSite');
            return false;
         } else if (this.uploadComp.selectSiteName.name !== namesite) {
            this.handleToastError('newTask.errorSiteCompat');
            return false;
         } else if (this.stepper.selectedIndex === 2) {
            if (this.taskAttribute.workflowId === 0 || this.taskAttribute.workflowId === undefined) {
               this.handleToastError('newTemplate.errorSelectWorkFlow');
               return false;
            }
         }
         this.checkErrorUploadNotFinish = true;
      }
      if(!this.uploadComp.isSignDate){
         this.uploadComp.dayLeft = 1;
      }
      if(!this.uploadComp.isEndDate){
         this.uploadComp.deletDayleft = 1;
      }
      return true;
   }

   addRecipientChangeStep2() { // ตรวจเช็คเงื่อนไขเมื่อเข้าหน้า sign
      if (this.pageType === 'task') {
         this.checkErrorRecipient = false; // reset check case add recipeint
         this.checkErrorSelectRecipient = false; // reset check case select order reciepnt
         this.checkErrorUploadNotFinish = false;
         if (this.uploadChangeStep1()) {
            let isNotHaveSigner = false;
            let isRequireNoOfSigner = false;
            let messList = '';

            if (this.taskAttribute.apvLevel.length === 0) {
               this._isShowTutorial = false;
               this.handleToastError('newTask.errorAddRecipient');
               return false;
            } else if (this.uploadComp.object_file !== null && this.uploadComp.object_file !== undefined
               && this.uploadComp.object_file.length > 0) {
               this.handleToastError('newTask.errorUploadFileNotFinish');
            } else {
               this.checkErrorRecipient = true;
               this.checkErrorUploadNotFinish = true;
            }

            for (let i = 0; i < this.taskAttribute.apvLevel.length; i++) {
               if (this.taskAttribute.apvLevel[i].signerList.length === 0) {
                  isNotHaveSigner = true;
                  if (messList !== '') {
                     messList += ', ';
                  }
                  messList += (i + 1);
               } else if (this.taskAttribute.apvLevel[i].numOfSigner === 0) {
                  for (let j = 0; j < this.taskAttribute.apvLevel[i].signerList.length; j++) {
                     if (this.taskAttribute.apvLevel[i].signerList[j].action.toLowerCase() === 'need to sign') {
                        isRequireNoOfSigner = true;
                        if (messList !== '') {
                           messList += ', ';
                        }
                        messList += (i + 1);
                        break;
                     }
                  }
               }
            }

            if (isNotHaveSigner) {
               this._isShowTutorial = false;
               this.handleToastError('newTask.errorAddRecipientOrder', messList);
            } else if (isRequireNoOfSigner) {
               this._isShowTutorial = false;
               this.handleToastError('newTask.errorSelectRecipientOrder', messList);
            } else {
               this.checkErrorSelectRecipient = true;
            }
         }

         if (this.flowRecipient.groups) {
            for (let i = 0; i < this.flowRecipient.groups.length; i++) {
               this.flowRecipient.groups[i].order = i + 1;
            }
         }
      } else {
         if (this.uploadChangeStep1()) {
            this.checkErrorSelectRecipient = false;
            this.checkErrorRecipient = false; // reset check case add recipeint
            if (this.taskAttribute.workflowId === 0 || this.taskAttribute.workflowId === undefined) {
               this.handleToastError('newTemplate.errorSelectWorkFlow');
               this.stepper.previous();
            } else {
               this.checkErrorSelectRecipient = true;
               this.checkErrorRecipient = true;
               for (let i = 0; i < this.flowRecipient.groups.length; i++) {
                  this.flowRecipient.groups[i].order = i + 1;
               }
               if (this.checkIsNeedToSign() > 0) {
                  this.createTaskSignOffComp.leftPanelComp.isHideSigner = true; // fixed bug show signer item when have user action sign
                  if (this.taskAttribute.apvLevel.length > 0) {
                     if (this.createTaskSignOffComp.leftPanelComp.toolsComp) {
                        this.createTaskSignOffComp.signerSelected = this.createTaskSignOffComp
                           .leftPanelComp.toolsComp.addNewSigner(this.taskAttribute.apvLevel);
                     }
                  }
               } else {
                  this.createTaskSignOffComp.leftPanelComp.isHideSigner = false; // fixed bug hide signer item when have user action sign
               }
               if (this.createTaskSignOffComp.leftPanelComp.toolsComp) {
                  this.createTaskSignOffComp.leftPanelComp.toolsComp.setSigners(this.taskAttribute.apvLevel);
               }

               this.getDoc = [];
               this.getDoc.push(this.taskAttribute.docList[0].docId);
               this.getThumbnailCreate(this.getDoc);
               this.tabBar = true;
            }
         }
      }
      this.checkPDF = false;
      let havePdf = false;
      let haveNeedtoSign = false;
      for (let k = 0; k < this.uploadComp.mimetype.length; k++) {
         if (this.uploadComp.mimetype[k].type.endsWith('/pdf')) {
            havePdf = true;
            continue;
         } else if (this.uploadComp.mimetype[k].type.endsWith('/zdox') === false) {
            havePdf = true;
            continue;
         }
      }
      for (let i = 0; i < this.taskAttribute.apvLevel.length; i++) {
         if (this.taskAttribute.docList.length && this.taskAttribute.docList[i]?.isForm) {
            havePdf = true
            continue;
         }
         for (let j = 0; j < this.taskAttribute.apvLevel[i].signerList.length; j++) {
            if (this.taskAttribute.apvLevel[i].signerList[j].action.toLowerCase() === 'need to sign') {
               haveNeedtoSign = true;
               break;
            }
         }
      }
      if (haveNeedtoSign) {
         if (havePdf) {
            this.checkPDF = true;
         }
      } else {
         this.checkPDF = true;
      }
   }

   onChangeTemplate($event) {
      this.createTaskSignOffComp.isInitail = false;
      this.createTaskSignOffComp.clearAllSign();
   }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   onChangeForm($event) {
      this.createTaskSignOffComp.isInitail = false;
      this.sections = undefined;
   }

   onStepChange($event) { // ดัก event step change

      if (this.ignoreSelectionChange) {
         this.ignoreSelectionChange = false;
         return;
      }
      const hasChanged = localStorage.getItem('onChanged');
      if (hasChanged && $event.previouslySelectedIndex === 2) {
         this.ignoreSelectionChange = true;
         Promise.resolve().then(() => {
            this.stepper.selectedIndex = $event.previouslySelectedIndex;
         });
         this.handleUnsavedChangesOnExit((canExit) => {
            if (canExit) {
               this.ignoreSelectionChange = true;
               if ($event.selectedIndex === 0) {
                  this.stepper.selectedIndex = 0;
               }
               localStorage.removeItem('onChanged');
            }
         });
         return;
      }

      switch ($event.selectedIndex) {
         case 0:
            this.tabBar = false;
            this.setToggle(false);
            break;
         case 1:
            if (this.pageType === 'task') { // ตั้งค่าเริ่มต้นให้หน้า task-sign-off
               this.createTaskSignOffComp.leftPanelComp.docListComp.documents = this.taskAttribute.docList;
               if (this.taskAttribute.workflowId && this.flowRecipient.flow) {
                  this.flowRecipient.flow.getFlowList(this.taskAttribute.workflowId);
               }
            }
            this.uploadChangeStep1(); // เช็คเงื่อนไขการ upload ต่างๆว่าผ่านไหม
            if (!this.isToggleRightOpened) { // ตั้งค่า toggle menu ให้มันเป็นแบบเริ่มต้น
               this.toggleRight();
            }
            if (!this.isToggleLeftOpened) {
               this.toggleLeft();
            }

            this.tabBar = false;
            this.setToggle(false);
            break;
         case 2:
            this._isShowTutorial = true;
            if (this.taskAttribute.formName) {
               // ZE-6502: an eForm must always render centered at the Signature step,
               // even after the form is changed in step 1. Earlier step transitions
               // (e.g. re-opening the right panel in step 2) can leave the sign-off
               // toggle in the "open" state, which makes the form left-aligned.
               // Reset it so the form is centered, matching the first-time flow.
               this.createTaskSignOffComp.isToggle = true;
            }
            this.addRecipientChangeStep2(); // เช็คเงื่อนไขในการสร้าง flow ว่าผ่านไหม
            if (this.pageType === 'task') { // กรณีเป็น task จะเช็คเงื่อนไจต่างๆ
               if ((this.taskAttribute.workflowId && this.checkErrorUploadNotFinish)
                  || (this.checkErrorRecipient && this.checkErrorSelectRecipient)) { // ถ้าใน step1 และ step2 ไม่มีการกำหนดค่าที่ผิดจะให้สามารถเปิดไปหน้า signtask ได้
                  if (this.checkIsNeedToSign() > 0) {
                     this.createTaskSignOffComp.leftPanelComp.isHideSigner = true; // fixed bug show signer item when have user action sign
                  } else {
                     this.createTaskSignOffComp.leftPanelComp.isHideSigner = false; // fixed bug hide signer item when have user action sign
                  }
                  if (this.taskAttribute.apvLevel.length > 0) { // ถ้ามีการตั้งค่า flow มาแล้วให้ bind data ลงในเมนูฝั่งซ้าย
                     if (this.createTaskSignOffComp.leftPanelComp.toolsComp) {
                        this.createTaskSignOffComp.leftPanelComp.toolsComp.selected = 0;
                        this.createTaskSignOffComp.signerSelected = this.createTaskSignOffComp
                           .leftPanelComp.toolsComp.addNewSigner(this.taskAttribute.apvLevel);
                     }
                     this.createTaskSignOffComp.leftPanelComp.selectedTab = 0;
                  }
                  this.createTaskSignOffComp.leftPanelComp.docListComp.documents = this.taskAttribute.docList; // ตั้งค่าเริ่มต้นรายการของเอกสาร
                  if (this.createTaskSignOffComp.leftPanelComp.attachComp) {
                     this.createTaskSignOffComp.leftPanelComp.attachComp.setListDocSelect();
                  }
                  if (this.checkErrorSelectRecipient) {
                     this.getThumbnailCreate(this.getDocumentsId());
                     this.createTaskSignOffComp.changeDrawPage(0);

                  } else { // fixed bug when backward to step
                     if (this.createTaskSignOffComp.currentIndex !== -1) {
                        if (this.taskAttribute.formName) {
                           this.createTaskSignOffComp.changeDrawPage(0);
                        } else {
                           this.createTaskSignOffComp.changeDrawPage(this.createTaskSignOffComp.currentIndex);
                        }
                     }
                  }
                  if (this.createTaskSignOffComp.leftPanelComp.toolsComp) {
                     this.createTaskSignOffComp.leftPanelComp.toolsComp.setSigners(this.taskAttribute.apvLevel);
                  }
                  this.createFormSections();
                  this.tabBar = true;
               }
            }
            break;
         default:
            this.tabBar = false;
            break;
      }
      if (this.taskAttribute.taskName === '' || this.taskAttribute.taskName === undefined) { // ตั้งค่าแสดง ไม่แสดงปุ่มต่างๆตาม taskName
         this.disableButtonSign = true;
      } else if (this.taskAttribute.docList.length === 0 && !this.taskAttribute.formName) {
         this.disableButtonSign = true;
      } else if (this.taskAttribute.apvLevel.length === 0) {
         this.disableButtonSign = true;
      } else if (this.taskAttribute.apvLevel.length > 0) {
         for (let i = 0; i < this.taskAttribute.apvLevel.length; i++) {
            if (this.taskAttribute.apvLevel[i].numOfSigner === 0) {
               for (let j = 0; j < this.taskAttribute.apvLevel[i].signerList.length; j++) {
                  if (this.taskAttribute.apvLevel[i].signerList[j].action.toLowerCase() === 'need to sign') {
                     this.disableButtonSign = true;
                     break;
                  } else {
                     this.disableButtonSign = false;
                  }
               }
            } else {
               this.disableButtonSign = false;
            }
         }
      } else {
         this.disableButtonSign = false;
      }
   }

   createFormSections() {
      const initFormService = (data: any) => {
         this.eFormService.initailization();
         this.eFormService.storeMetaField(data.formName, data.key);
         this.eFormService.storeSection(data.sections)
         this.eFormService.storeValue(data.value ?  JSON.parse(data.value) : '');
         if (data.sections.length > 0) {
            this.sections = data.sections;
            this.setfirstSignField(this.sections);
            this.checkSignatureField();
            for (let indexSection = 0; indexSection < this.sections.length; indexSection++) {
               const fieldsLength = this.sections[indexSection].fields.length;
               for (let indexField = 0; indexField < fieldsLength; indexField++) {
                  if (this.sections[indexSection].fields[indexField].fieldName === '') {
                     this.sections[indexSection].fields[indexField].fieldNameEmpty = 'fieldName' + indexSection + indexField;
                  }
               }
            }

            data.sections.forEach(element => {
               element.fields.forEach(field => {
                  if (field.type === 'signature') {
                     if ((this.eFormService.eForm.value.value && !this.eFormService.eForm.value.value[field.fieldName]) || !this.eFormService.eForm.value.value) {
                        this.createTaskSignOffComp.showSignTool(true);
                     }
                  }
               });
            });
         }
      }

      if (this.taskAttribute.formName && !this.sections && this.taskAttribute.formList.formId) {
         this.api.selectEForm(this.taskAttribute.formList.formId,  this.taskAttribute.taskName, this.taskAttribute.formList.tin).subscribe((res) => {
            const data = res.body
            this.eFormService.formValue.docId = data.docId;
            this.taskAttribute.formList.alfFormId = data.docId;
            this.fileFormName = data.docName

            for (let i = 0; i < this.taskAttribute.docList.length; i++) {
               if (this.taskAttribute.docList[i].isForm && !this.taskAttribute.docList[i].isUpload) {
                  this.taskAttribute.docList[i].docId = data.docId;
                  break;
               }
            }

            this.api.getEForm(this.taskAttribute.formList.formId).subscribe((res) => {
               const data = res.body.data;
               if (data?.value) {
                  this.eFormService.formValue.value = data.value;
               }
               initFormService(data)
            }, (err) => {
               console.error(err);
            });
         }, (err) => {
            console.error(err);
         });
      } else if (this.taskAttribute.formName && !this.sections && !this.taskAttribute.formList.formId) {
         let docId = '';
         for(let i = 0; i < this.taskAttribute.docList.length; i++) {
            if (this.taskAttribute.docList[i].isForm) {
               docId = this.taskAttribute.docList[i].docId;
               this.fileFormName = this.taskAttribute.docList[i].docName;
               break;
            }
         }
         this.eFormService.formValue.docId = docId;
         this.api.getEFormFormDocId(docId).subscribe(res => {
            if (res) {
               const data = res.body.data;
               if (data.value) {
                  this.eFormService.formValue.value = JSON.parse(data.value);
               }
               initFormService(data)
            }
         }, (err) => {
            console.error(err);
         });
      }
   }

   getEFormFormDocId (docId){
      this.api.getEFormFormDocId(docId).subscribe(res => {

         if (res) {
            const data = res.body.data;
            let formSelectName;
            for (const [key, value] of Object.entries(data.formName)) {
               if (value){
                  formSelectName = value;
                  break;
               }
            }
            if (formSelectName){
               this.taskAttribute.formName = formSelectName;
            }
         }
      }, (err) => {
         console.error(err);
      });
   }


   /**
    * handle event หลังจากที่กด next หรือ previous step จะเข้ามา action ในนี้
    */
   _animationDone(stepper) {
      if (!this.checkErrorUploadNotFinish) { // กรณีที่ upload ยังไม่เสร็จ
         this.stepper.selectedIndex = 0;
      } else if (!this.checkErrorRecipient || !this.checkErrorSelectRecipient) { // กรณีที่ในหน้า flow recipient เกิด error
         if (this.stepper.selectedIndex === 2) { // จะย้อนกลับไป index 1 คือหน้า flow recipient
            this.stepper.selectedIndex = 1;
         }
      }
      this.createTaskSignOffComp.setDeselectItem(''); // ตั้งค่าให้ไม่มีการ select ลายเซ็นต์ หรือ item ใดๆทั้งสิ้นใน page
      this.createTaskSignOffComp.finishSVG(''); // reset ค่าการวาดลายเซ็นต์เผื่อมีหลุดเคสเมื่อสร้างลายเซ็นต์ทิ้งไว้แล้ว previous step กลับมา
      if (this.createTaskSignOffComp.countZoom > 0) { // ถ้ามีการ zoom มาก่อนแล้ว previous step กลับมา หรือเลือก step อื่นๆ นอกจาก 2 ให้ reset ค่า zoom
         this.createTaskSignOffComp.checkheightpage = this.createTaskSignOffComp.checkheightpage / this.createTaskSignOffComp.countZoom;
         this.createTaskSignOffComp.ZoomPage(false, parseFloat(this.createTaskSignOffComp.countZoom.toFixed(1)), 'current');
         this.createTaskSignOffComp.countZoom = 0;
      }
   }

   /**
    * delete file ทั้งหมดที่ทำการ upload ขึ้นไปบน alfresco แล้วทิ้ง
    */
   deleteAllFile(btnBack?: any, btnCancel?: any, btnSave?: any, btnSend?: any) {
      this.setToggle();
      this.createTaskSignOffComp.handleWaitAction(true); // เปิด progress loading
      if (this.pageType === 'task') { // disable ปุ่มก่อนเพื่อกันคนเกรียนกดปุ่มรัวๆ
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true);
      }

      if (this.taskAttribute.tempId) { // กรณี save pdftron แล้วกด สลับกลับ แล้วกด cancel
         this.upNewTemp(this.taskAttribute, btnBack, btnCancel, btnSave, btnSend);
      } else { // เคส ไม่สลับกลับ กด cancel อยู่หน้า pdftron เลย
         if(localStorage.getItem('newTempId')) {
            this.taskAttribute.tempId = localStorage.getItem('newTempId').split(',')[0];
            this.upNewTemp(this.taskAttribute, btnBack, btnCancel, btnSave, btnSend);
            localStorage.removeItem('newTempId');
         }
      }
      if (this.mode !== 'edit') { // ถ้าไม่ใช่ draft ใน task หรือ edit ใน template
         if (this.taskAttribute.docList.length > 0) {
            for (let i = 0; i < this.taskAttribute.docList.length; i++) {

               const docId = this.taskAttribute.docList[i].docId;
               if (this.data.item !== undefined && this.data.item.id === docId) { // ถ้ามีเอกสารนี้บนระบบอยู่แล้วให้ทำการ revert version
                  this.service.revertVersionTask(docId, this.versionDoc, this.taskAttribute.taskId)
                     .subscribe(data => {
                        this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                        this.closePage(true);
                     }, error => {
                        this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                        this.closePage(true);
                     });
               } else if (this.data.item !== undefined && this.data.item.id !== docId) { // ถ้ายังไม่มีเอกสารนี้ให้ทำการ ลบทิ้ง
                  if (this.taskAttribute.docList[i].isDocList !== true) {
                     this.service.deleteDocument(docId)
                        .subscribe((response) => {
                              this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                           },
                           (err) => {
                              this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                           });
                  }
                  this.closePage(true);
               } else if (this.data.item === undefined) {
                  if (!this.taskAttribute.docList[i].isDocList && !this.taskAttribute.docList[i].isForm) {
                     this.service.deleteDocument(docId) // ถ้าไม่ใช่โหมด edit (draft ใน task, edit ใน template) ลบ document ทิ้ง
                        .subscribe((response) => {
                              this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                           },
                           (err) => {
                              this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                           });
                  }
                  this.closePage(true);
               }
            }
         } else {
            this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
            this.closePage(true);
         }
      } else { // กรณีเป็น draft ใน task หรือ edit ใน template

         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            const document = this.taskAttribute.docList[i];
            if (document.isUpload && document.isDocList !== true) {
               this.service.deleteDocument(document.docId)
                  .subscribe((response) => { // ลบเอกสารที่มาจากการ upload ใหม่ทิ้ง
                        this.createTaskSignOffComp.handleWaitAction(false);
                     },
                     (err) => {
                        this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                     });
            }
         }

         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            const docId = this.taskAttribute.docList[i].docId;
            const docNewIndex = this.uploadComp.docNew.indexOf(docId);
            if (docNewIndex < 0) { // ถ้า docId นี้ไม่ใช่เอกสารใหม่ให้ทำการ revert version
               const version = this.taskAttribute.docList[i].version;
               this.service.revertVersionTask(docId, version, this.taskAttribute.taskId)
                  .subscribe(data => {
                     this.createTaskSignOffComp.handleWaitAction(false);
                  }, error => {
                     this.createTaskSignOffComp.handleWaitAction(false);
                  });
            }
         }
         this.closePage(true);
      }
      if (this.pageType === 'task') { // enable ปุ่มหลังจากที่ การทำงานทุกอย่าเงเสร็จหมด
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
      }
   }

   disableBtn(btnBack: any, btnCancel: any, btnSave: any, btnSend: any, isDisable: boolean) {
      if (btnBack) {
         btnBack.disabled = isDisable;
      }
      if (btnCancel) {
         btnCancel.disabled = isDisable;
      }
      if (btnSave) {
         btnSave.disabled = isDisable;
      }
      if (btnSend) {
         btnSend.disabled = isDisable;
      }
   }

   /**
    * ตัวสอบการ validate ต่างๆ
    */
   validateSubmit(isDraft?: boolean) {
      const namesite = this.nameSite ? this.nameSite.substring(3) : this.nameSite;

      if (this.pageType === 'task') {
         let isNotHaveSigner = false;
         let isRequireNoOfSigner = false;
         let messList = '';
         if (this.taskAttribute.taskName === '' || this.taskAttribute.taskName === undefined
            || this.taskAttribute.taskName.indexOf('\\') !== -1 || this.taskAttribute.taskName.indexOf('|') !== -1) {
            this.handleToastError('newTask.errorInputTaskName'); // ไม่มีการตั้งชื่อ task
            this.stepper.selectedIndex = 0;
            return false;
         } else if (this.taskAttribute.docList.length === 0) {
            this.handleToastError('newTask.errorSelectFile'); // ไม่มีการ upload file
            this.stepper.selectedIndex = 0;
            return false;
         } else if (this.uploadComp.selectSiteName.name !== namesite) {
            this.handleToastError('newTask.errorSiteCompat');
            return false;
         } else if (this.taskAttribute.siteId === '' || this.taskAttribute.siteId === undefined) {
            this.handleToastError('newTask.errorSelectSite');
            return false;
         } else if (this.uploadComp.object_file !== null && this.uploadComp.object_file !== undefined
            && this.uploadComp.object_file.length > 0) {
            this.handleToastError('newTask.errorUploadFileNotFinish'); // ยัง upload ไม่เสร็จแล้วกด next หรือเปลี่ยน step
            this.stepper.selectedIndex = 0;
            return false;
         } else if (this.taskAttribute.apvLevel.length === 0) {
            this.handleToastError('newTask.errorAddRecipient'); // ไม่มีการเลือก flow
            this.stepper.selectedIndex = 1;
            return false;
         }  else if (
            this.taskAttribute.formName &&
            !this.createTaskSignOffComp.checkFormValid(this.signerData) &&
            !isDraft
         ) {
            this.createTaskSignOffComp.changePageOnCheck();
            if (this.createTaskSignOffComp.checkIfInvalidRequiredFieldsOnlySignatures()) { // ไม่มีการกรอกข้อมูลใน field ที่ต้องกรอก
               this.handleToastError('newTask.errorSelectSigner'); // ถ้า required field มีแต่ field ช่องกรอกลายเซ็น ให้แสดง errorSelectSigner (ZE-4836)
            }
            // else {
            //    this.handleToastError('newTask.errorFormInvalidField'); // ถ้า required field มี field อื่นที่นอกเหนือจากช่องกรอกลายเซ็น ให้แสดง errorFormInvalidField
            // }
            return false;
         }  else if (this.signatureLength && this.signerData.length < this.signatureLength && !this.alreadySign && !isDraft) {
            this.createTaskSignOffComp.validateForm(this.signerData);
            this.createTaskSignOffComp.changePageOnCheck();
            this.handleToastError('newTask.errorSelectSigner'); // ไม่มีการเลือกลำดับคนที่ต้องเซ็นต์
            return false;
         }

         for (let i = 0; i < this.taskAttribute.apvLevel.length; i++) {
            if (this.taskAttribute.apvLevel[i].signerList.length === 0) {
               isNotHaveSigner = true;
               if (messList !== '') {
                  messList += ', ';
               }
               messList += (i + 1);
            } else if (this.taskAttribute.apvLevel[i].numOfSigner === 0) {
               for (let j = 0; j < this.taskAttribute.apvLevel[i].signerList.length; j++) {
                  if (this.taskAttribute.apvLevel[i].signerList[j].action.toLowerCase() === 'need to sign') {
                     isRequireNoOfSigner = true;
                     if (messList !== '') {
                        messList += ', ';
                     }
                     messList += (i + 1);
                     break;
                  }
               }
            }
         }

         if (isNotHaveSigner) { // ถ้าไม่มีการเลือกคนที่ทำรายการให้เซ็นต์ใน flow จะไม่ยอมให้ผ่าน
            this.handleToastError('newTask.errorAddRecipientOrder', messList);
            this.stepper.selectedIndex = 1;
            return false;
         } else if (isRequireNoOfSigner) { // ถ้าามีการเลือกคนที่ทำรายการให้เซ็นต์ใน flow แต่ไม่ยอมเลือกจำนวนคนที่ต้องเซ็นต์จะไม่ยอมให้ผ่าน
            this.handleToastError('newTask.errorSelectRecipientOrder', messList);
            this.stepper.selectedIndex = 1;
            return false;
         }
         return true;
      } else {
         if (this.taskAttribute.taskName === '' || this.taskAttribute.taskName === undefined) {
            this.handleToastError('newTemplate.errorInputTemplateName'); // ไม่มีการตั้งชื่อ template
            this.stepper.selectedIndex = 0;
            return false;
         } else if (this.taskAttribute.docList.length === 0) {
            this.handleToastError('newTemplate.errorSelectFile'); // ไม่มีการ upload file
            this.stepper.selectedIndex = 0;
            return false;
         } else if (this.uploadComp.object_file !== null && this.uploadComp.object_file !== undefined
            && this.uploadComp.object_file.length > 0) {
            this.handleToastError('newTemplate.errorUploadFileNotFinish'); // uploda file ยังไม่เสร็จแล้วกด next หรือเปลี่ยน step
            this.stepper.selectedIndex = 0;
            return false;
         } else if (this.taskAttribute.workflowId === 0 || this.taskAttribute.workflowId === undefined) {
            this.handleToastError('newTemplate.errorSelectWorkFlow'); // ไม่มีการเลือก workflow
            this.stepper.selectedIndex = 1;
            return false;
         } else if (this.taskAttribute.docList[0].signItems === undefined || this.taskAttribute.docList[0].signItems.length <= 0) {

            let isHaveNS = false;
            for (const signers of this.taskAttribute.apvLevel) {
               for (const signer of signers.signerList) {
                  if (signer.action === this._actionNeedToSign || signer.action === this._actionExternalSign) {
                     isHaveNS = true;
                     break;
                  }
               }
               if (isHaveNS) {
                  break;
               }
            }

            if (isHaveNS) {
               this.handleToastError('newTemplate.errorAddField'); // ถ้าไม่มีการ add field ซัก field แล้วกดสร้างหรือ save template เลยจะไม่ผ่าน
               this.createTaskSignOffComp.leftPanelComp.selectedTab = 1;
               this.stepper.selectedIndex = 2;
               return false;
            }
         } else {
            let isHaveSign = false;
            for (const signItem of this.taskAttribute.docList[0].signItems) {
               if (signItem.fieldType === 'signature' || signItem.fieldType === 'initSignature') {
                  isHaveSign = true;
                  break;
               }
            }

            if (!isHaveSign) {
               this.handleToastError('newTemplate.errorAddField'); // ถ้าไม่มีการ add field ซัก field แล้วกดสร้างหรือ save template เลยจะไม่ผ่าน
               this.createTaskSignOffComp.leftPanelComp.selectedTab = 1;
            }
            return isHaveSign;
         }
         return true;
      }
   }

   /**
    * เมื่อกดปุ่ม save ในหน้าวางลายเซ็นต์ทั้ง create Task และ template
    */
   actionSave(btnBack: any, btnCancel: any, btnSave: any, btnSend: any) {
      if (this.validateSubmit(true)) { // เมื่อผ่านการ validate แล้ว
         this.createTaskSignOffComp.handleWaitAction(true); // เปิด progress loading
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true); // disable ปุ่มกันคนเกรียนกดรัวๆ
         this.createTaskSignOffComp.deselectAll(); // deselect ทุก items หรือลายเซ็นต์ทั้งหมดที่เลือกไว้อยู่ทิ้ง
         this.revertDataToNormalSize(this.taskAttribute.docList, this.createTaskSignOffComp.isZoom); // แปลงตำแหน่งและขนาดกลับกรณีที่มีการ zoom อยู่
         this.taskAttribute.idFolderExport = this.uploadComp.idFolderExport; // ตั้งค่า id folder ที่จะ export ไป
         this.taskAttribute.exportStatus = this.uploadComp.exportOption; // ตั้งค่า option ที่เลือกในการ export
         this.createTaskSignOffComp.setTextContent();
         this.service.saveTask(this.taskAttribute)
            .subscribe((suc) => { // call service saveTask
                  this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading
                  this.uploadComp.submitDeleteFile(); // ลบเอกสารทั้งหมดที่ทำการ delete ในหน้า thumbnails
                  this.createTaskSignOffComp.submitDeleteFile(); // ลบ image ที่มีการ delete ที่หน้า Draft
                  this.toast.success(suc); // แสดง message success
                  this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false); // enable ปุ่ม
                  this.closePage();
               },
               (err) => {
                  this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading
                  this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
                  console.error(err);
               },
               () => {
                  if ((this.eFormService.formValue.docId || this.eFormService.formValue.id) && this.taskAttribute.formName) {
                     this.onCheckSubmit();
                  } else {
                     this.closePage();
                  }
               });
      } else {
         this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false); // enable ปุ่ม
      }
   }

   async actionSend(btnBack: any, btnCancel: any, btnSave: any, btnSend: any) {
      if (this.taskAttribute.taskName.indexOf('\\') !== -1 || this.taskAttribute.taskName.indexOf('|') !== -1) {
         this.stepper.selectedIndex = 0;
      }
      this.createTaskSignOffComp.dynamicFormComp?.enableShowFieldEmptyError();
      const isValueError = await this.createTaskSignOffComp.isValueFormatError();
      if (this.pageType === 'task' && this.taskAttribute.formName && isValueError) {
         return;
      }
      if (this.validateSubmit()) { // เมื่อผ่านการ validate แล้ว
         this.createTaskSignOffComp.handleWaitAction(true); // เปิด progress loading
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true); // disable ปุ่มกันคนเกรียนกดรัวๆ
         this.createTaskSignOffComp.deselectAll(); // deselect ทุก items หรือลายเซ็นต์ทั้งหมดที่เลือกไว้อยู่ทิ้ง
         this.addEmptySignItem(); // bind data array ว่างๆให้ กรณีที่เอกสารไหนไม่มีลายเซ็นต์
         this.revertDataToNormalSize(this.taskAttribute.docList, this.createTaskSignOffComp.isZoom); // แปลงตำแหน่งและขนาดกลับกรณีที่มีการ zoom อยู่
         if (this.data.typeName === 'startFlow') { // ตั้งค่า isDocList เพื่อให้ update บน database ว่ามาจากการ startflow
            this.taskAttribute.docList[0].isDocList = true;
            this.isDocList = true;
         } else {
            if (this.taskAttribute.docList[0].isDocList) {
               this.isDocList = true;
            } else {
               this.isDocList = false;
            }
         }

         const docForm = this.taskAttribute.docList.find(o => o.isForm);
         if (docForm) {
            docForm.signItems.push(...this.signerData);
         }
         this.taskAttribute.idFolderExport = this.uploadComp.idFolderExport; // ตั้งค่า id folder ที่จะ export ไป
         this.taskAttribute.exportStatus = this.uploadComp.exportOption; // ตั้งค่า option ที่เลือกในการ export
         this.createTaskSignOffComp.setTextContent();
         let payload: any;
         if ((this.eFormService.formValue.docId || this.eFormService.formValue.id) && this.taskAttribute.formName) {
               if (this.taskAttribute.templateId && this.taskAttribute.templateName) {
                  payload = {
                     form: this.eformSubmitPayload()
                  }
               }
         }

         this.service.sendTask(this.taskAttribute, this.isDocList, this.uploadComp.backupIdFolderExport, this.uploadComp.backupPathExport, payload)
         .subscribe((suc) => { // call service sendTask
               this.deleteFileTempAndAnno();
               this.createTaskSignOffComp.handleWaitAction(true); // เปิด progress loading
               this.uploadComp.submitDeleteFile(); // ลบเอกสารทั้งหมดที่ทำการ delete ในหน้า thumbnails
               this.toast.success(suc); // แสดง message success
               this.googleAnalyticsService.trackEvent('zdox-create-task',{
                  event_page: "create-task",
                  event_label: "send task",
                  event_action: "send"
               });
               this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false); // enable ปุ่ม
               if (!this.eFormService.formValue?.docId && !this.eFormService.formValue?.id) {
                  this.closePage();
               }
            },
            (err) => {
               this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading
               this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
               console.error(err);
            },
            () => {
               if ((this.eFormService.formValue.docId || this.eFormService.formValue.id) && this.taskAttribute.formName && !payload) {
                  this.onCheckSubmit();
               } else {
                  this.closePage();
               }
            });
      } else {
         this.createTaskSignOffComp.handleWaitAction(false);
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
      }
   }

   /* เช็ค package เพื่อดูว่าส่ง task ได้กี่ครั้ง ครบหรือยัง */
   onCheckQuotaTask(btnBack: any, btnCancel: any, btnSave: any, btnSend: any) {
      this.createTaskSignOffComp.handleWaitAction(true); // เปิด progress loading
      this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true); // disable ปุ่มกันคนเกรียนกดรัวๆ
      this.service.checkQuotaTask()
         .subscribe(data => {
            this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false); // enable ปุ่ม
            this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading
            if (data.profile.packageTask !== undefined && data.profile.packageTask !== ''
               && data.profile.packageTask === 'FREE') {
               if (this.service.user.business) {
                  if (data.countTasks < 10) {
                     this.actionSend(btnBack, btnCancel, btnSave, btnSend);
                  } else {
                     this.openPackageDialog();
                  }
               } else if (data.profile.quotaTask !== undefined && data.profile.quotaTask !== 0
                  && data.profile.quotaTask > data.countTasks) {
                  this.actionSend(btnBack, btnCancel, btnSave, btnSend);
               } else {
                  this.openPackageDialog();
               }
            } else {
               this.actionSend(btnBack, btnCancel, btnSave, btnSend);
            }
         }, error => {
            this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true); // disable ปุ่มกันคนเกรียนกดรัวๆ
            this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading
         });
   }

   openPackageDialog() {
      this.viewPackage = this.dialog.open(PackageDialogComponent, {
         disableClose: true,
         data: this,
         width: '450px'
      });
   }

   /**
    * เช็คว่ายังไม่ลายเซ็นต์ที่ยังไม่ได้ทำการเซ็นต์หรือไม่
    */
   checkIsNeedToSign() {
      let count = 0;
      for (const signers of this.taskAttribute.apvLevel) {
         for (const signer of signers.signerList) {
            if (signer.action === this._actionNeedToSign || signer.action === this._actionExternalSign) {
               count++;
            }
         }
      }
      return count;
   }

   onFlowChange(data) { // clear signitems in document when change flow
      this.taskAttribute.workflowId = data.workflowId;
      this.uploadComp.taskAttribute.workflowName = data.workflowName;
      if (this.pageType === 'task') {
         if (!this.taskId) {
            this.taskAttribute.apvLevel = [];
            for (const apv of data.apvLevel) {
               if (apv.order !== -1) {
                  this.taskAttribute.apvLevel.push(apv);
               }
            }
            if (!this.taskAttribute.templateId) {
               for (let i = 0; i < this.taskAttribute.docList.length; i++) {
                  this.taskAttribute.docList[i].signItems = [];
               }
            }
         }
      } else {
         this.taskAttribute.apvLevel = data.apvLevel;
         if (this._initial) {
            this.taskAttribute.docList[0].signItems = [];
         } else {
            this._initial = true;
         }
      }
   }

   handleToastError(key, msgList?) {
      this.translate.get(key).subscribe((msg) => {
         if (msgList) {
            this.toast.error(msg + msgList);
         } else {
            this.toast.error(msg);
         }
      });
   }

   addEmptySignItem() {
      for (const document of this.taskAttribute.docList) {
         if (!document.signItems) {
            document.signItems = [];
         }
      }
   }

   /**
    * ปิดการ drag object ในฝั่ง เมนูบางตัวที่ไม่ต้องการให้ drag
    */
   onDragOverDisable($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.dataTransfer.effectAllowed = 'none';
      $event.dataTransfer.dropEffect = 'none';
   }

   back() {
      if (this.taskAttribute.tempId) {
         this.service.deleteDocument(this.taskAttribute.tempId).subscribe(() => {});
      }
      localStorage.removeItem('onChanged');
      const _haveForm = this.taskAttribute.docList.filter(doc => doc.isForm);
      const _formUploaded = this.taskAttribute.docList.filter(doc => doc.isForm && doc.isUpload);
      if (this.mode !== 'edit') {
         if (this.taskAttribute.docList.length > 0) {
            if(this.docId && ((_haveForm.length === 0 && _formUploaded.length === 0) || (_haveForm.length === 1 && _formUploaded.length === 1))) { // check docId not undefined and not have form from dropdown list
               this.service.getDocument(this.docId)
                  .subscribe(data => {
                     if (this.versionDoc !== data.version) {
                        this.versionDoc = data.version;
                     }
                     for (let i = 0; i < this.taskAttribute.docList.length; i++) {

                        const docId = this.taskAttribute.docList[i].docId;
                        if (this.data.item !== undefined && this.data.item.id === docId) { // revert version เฉพาะเอกสารที่มาจากการ startflow
                           this.service.revertVersionTask(docId, this.versionDoc, this.taskAttribute.taskId)
                              .subscribe(data => {
                                 this.createTaskSignOffComp.handleWaitAction(false);
                                 this.closePage(true);
                              }, error => {
                                 this.createTaskSignOffComp.handleWaitAction(false);
                                 this.closePage(true);
                              });
                        } else if ((this.data.item !== undefined && this.data.item.id !== docId) || this.data.item === undefined) {
                           if (this.taskAttribute.docList[i].isDocList !== true && this.taskAttribute.docList[i].isUpload) {
                              this.service.deleteDocument(docId)
                                 .subscribe((response) => { // ลบเอกสารทั้งหมดที่ไม่ได้มาจากการ startflow ทิ้ง
                                       this.createTaskSignOffComp.handleWaitAction(false);
                                    },
                                    (err) => {
                                       this.createTaskSignOffComp.handleWaitAction(false);
                                    });
                           }
                           this.closePage(true);
                        }
                     }
                  });
            } else {
               this.deleteFileAndRevert();
            }
         } else {
            this.createTaskSignOffComp.handleWaitAction(false);
            this.closePage(true);
         }
      } else {
         this.deleteFileAndRevert();
      }
   }

   //delete file upload and revert file
   deleteFileAndRevert(){

      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         const document = this.taskAttribute.docList[i];
         if (document.isUpload && document.isDocList !== true) {
            this.service.deleteDocument(document.docId)
               .subscribe((response) => { // ลบเอกสารที่มาจากการ upload ใหม่ทิ้ง
                     this.createTaskSignOffComp.handleWaitAction(false);
                  },
                  (err) => {
                     this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading หลัง action เสร็จ
                  });
         }
      }

      for (let i = 0; i < this.taskAttribute.docList.length; i++) {
         const docId = this.taskAttribute.docList[i].docId;
         const docNewIndex = this.uploadComp.docNew.indexOf(docId);
         if (docNewIndex < 0) {
            const version = this.taskAttribute.docList[i].version;
            this.service.revertVersionTask(docId, version, this.taskAttribute.taskId)
               .subscribe(data => { // revert version เอกสารเดิม
                  this.createTaskSignOffComp.handleWaitAction(false);
               }, error => {
                  this.createTaskSignOffComp.handleWaitAction(false);
               });
         }
      }
      this.closePage(true);
   }

   /**
    * ปิดหน้าแล้ว route ไปยังหน้าต่างๆตามเงื่อนไข
    */
   closePage(isClose?: boolean) {
      if (this.pageType === 'task') {
         if (isClose) {
            if (this.taskId && this.taskId !== 0) {
               this.service.closeTask(this.taskId).subscribe();
            }
         }
         if (this.createTaskSignOffComp) {
            if (this.createTaskSignOffComp.type === 'startFlow') {
               const path = localStorage.getItem('url');
               const search = '/search';
               let param;
               if (!path && path?.startsWith(search)) {
                  param = path.substring(path.indexOf('=') + 1);
                  this.router.navigate([search], {queryParams: {q: param}});
                  return;
               }
               this.router.navigate([localStorage.getItem('url')]);
               localStorage.removeItem('url');
            } else {
               if (sessionStorage.getItem('taskPath')) {
                  this.router.navigate([sessionStorage.getItem('taskPath')]);
               } else {
                  this.router.navigate(['/tasks/sign']);
               }
            }
         } else {
            if (sessionStorage.getItem('taskPath')) {
               this.router.navigate([sessionStorage.getItem('taskPath')]);
            } else {
               this.router.navigate(['/tasks/sign']);
            }
         }
      } else {
         if (this.autoApprove && !this.share) {
            this.router.navigate(['/auto-approve']);
         } else {
            this.router.navigate(['/templates']);
         }
      }
   }

   checkDevice() {
      const userAgent = navigator.userAgent;

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(userAgent)) {
         return false;
      } else {
         return true;
      }
   }

   getDocument(docId): void {
      const tId = this.pageType === 'task' ? this.taskId : this.id;
      this.service.getDocumentAdmin(docId, tId, this.pageType)
         .subscribe((data: any) => {
               if (!data) {
                  return;
               }
               this.doc = data;
               this.description = data.description;
               if (this.con !== undefined) {
                  this.con.nativeElement.value = data.description;
               }
               this.comment = data.comments;
               this.show = Mimetype.canEdit(this.doc);
               const fmt = new MomentPipe();
               this.lastModified = {when: fmt.transform(this.doc.modified)};
               if (!data.typeName) {
                  this.service.getTypes().subscribe(dataType => {
                        this.types = dataType;
                     },
                     (err) => {
                        console.error(err);
                     });
                  this.isAddMetadata = false;
                  this.settype = false;
               } else {
                  this.settype = true;
                  this.isAddMetadata = true;
                  setTimeout(() => {

                     if (this.doc.properties) {
                        this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, this.doc.properties);
                     }
                  }, 200);
               }
            },
            (error: any) => {
               // This is intentional.
            });
   }

   getComment(): void {
      this.service.getComment(this.docId).subscribe(
         data => {
            this.comment = data.items;
         });
   }

   /**
    *
    * @details : Save comment for user
    */
   saveComment(item: any, input: any) {
      if (input.value.trim().length === 0) {
         return;
      }
      let url;
      if (this.taskId) {
         url = '/comments/' + item.id + '/' + this.docId + '?taskId=' + this.taskId;
      } else {
         url = '/comments/' + item.id + '/' + this.docId;
      }
      this.service.put(url, {content: encodeURIComponent(input.value)})
         .subscribe(res => {
               item.editing = false;
               item.content = input.value;
            },
            (err) => {
               console.error(err);
            });
   }

   /**
    *
    * @details : Edit comment for user
    */
   editComment(item: any) {
      item.editing = true;
      setTimeout(() => {
         $('#edit-' + item.id).focus();
      }, 200);
   }

   /**
    *
    * @details : Delete comment for user
    */
   delComment(item: any): void {
      const dialogRef = this.dialog.open(DeleteCommentComponent, {
         disableClose: true,
         data: {service: this.service, item: item}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.comment.indexOf(item);
            if (i !== -1) {
               this.comment.splice(i, 1);
            }
         }
      });
   }

   /**
    *
    * @details : Add comment for user
    */

   postComment(button: MatButton, input: any): void {

      const text = input.value.trim();
      if (text.length === 0) {
         input.focus();
         return;
      }
      button.disabled = true;
      this.translate.get('sending').subscribe(s => {
         this.post = s;
      });
      this.service.postComment(this.docId, text, this.taskId).subscribe(
         () => {
            input.value = '';
            this.translate.get('sended').subscribe(s => {
               this.post = s;
            });
            this.getComment();
            setTimeout(() => {
               button.disabled = false;
               this.translate.get('send').subscribe(s => {
                  this.post = s;
               });
            }, 3000);
         },
         error => {
            button.disabled = false;
            this.translate.get('send').subscribe(s => {
               this.post = s;
            });
         });
   }

   onSelectedChange($event) {
      this.selectedTab = $event;
   }

   /**
    *
    * @details : Check all button when click button
    */

   onClickButtonAll($event) {
      if ($event.checked) {
         this.statechange = true;
         this.selectButton = true;
         this.checkAllSelected(this.imgThumbnails[this.createTaskSignOffComp.currentIndex].thumbnailSelect, true);
         this.ThumbnailComp.checkButtonAllRotate($event);
      } else {
         this.statechange = false;
         this.selectButton = false;
         this.checkAllSelected(this.imgThumbnails[this.createTaskSignOffComp.currentIndex].thumbnailSelect, false);
         this.ThumbnailComp.checkButtonAllRotate($event);
      }
      this.maxPage = this.ThumbnailComp.getMaxPage();
   }

   checkAllSelected(item, checked) {
      for (let i = 0; i < item.length; i++) {
         item[i].isSelected = checked;
      }
   }

   /**
    * Callback event เมื่อมีการกด document list ในเมนูฝั่งซ้าย
    */
   onListClick($event): void {
      // console.log(this.eFormService.eForm)
      if (this.ThumbnailComp) { // ถ้ามีการ render หน้า thumbnail แล้ว
         if (this.createTaskSignOffComp.currentIndex !== 0) { // ตั้งค่า complete task กรณีถ้า current index ไม่เป็น 0 คือจะยังไม่ Complete แน่นอน
            this.setDisableCompleteTask = false;
         } else { // ถ้าไม่ใช่ 0 ตั้งค่าตามที่ถูกตั้งค่ามา
            this.setDisableCompleteTask = this.isCompleteTask;
         }
      }
      this.scroll = 0;
      this.selectedValue1 = undefined;
      this.form = undefined;
      this.selectButton = false;
      this.selectedTab = 0;
      this.docId = $event;
      this.flagCheckSelectInsert = true;
      this.flagCheckSelect = false;
      this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, []); // สร้าง form document info ใหม่
      this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, []);
      for (let j = 0; j < this.totalPages; j++) {
         this.checkselectedItems[j] = false;
      }
      this.getDocument($event);
      this.statechange = false;
      this.maxPage = 0;
      if (this.createTaskSignOffComp.dataPages !== undefined && this.createTaskSignOffComp.dataPages.length > 0 && !this.createTaskSignOffComp.isFormName) {
         this.createTaskSignOffComp.setDocId($event);
         this.totalPages = this.createTaskSignOffComp.dataPages[this.createTaskSignOffComp.currentIndex].totalPages;
         this.dataWidthHeight = this.createTaskSignOffComp.dataPages[this.createTaskSignOffComp.currentIndex].pages;
         this.dataWidthHeightAll = this.createTaskSignOffComp.dataPages[this.createTaskSignOffComp.currentIndex].pages;
         if (this.totalPages > 0) {
            this.setInitialThumbnail(); // ตั้งค่าเริ่มต้นให้ thumbnails ถ้ามี data อยู่แล้ว
         }
      }
      if (this.getImageThumbnail()) {
         for (let index = 0; index < this.getImageThumbnail().lastPageLoaded; index++) {
            if (!this.getThumbnailsSelected()[index].isSelected) {
               $('.thumbnail_' + (index)).removeClass('active-thumbnails-height');
               $('.thumbnail_' + (index)).removeClass('active-thumbnails-width');
            }
         }
      }
      // จำค่าที่กรอกในฟอร์มไว้ ตอนเปลี่ยนเอกสารกลับมา จะได้แสดงค่าเดิมที่เคยกรอกไว้
      if (this.createTaskSignOffComp?.dynamicFormComp && this.sections && this.eFormService?.eForm?.value) {
         const formValue = this.createTaskSignOffComp.dynamicFormComp?.form?.value;
         if (formValue) {
            this.eFormService.eForm.value.value = formValue;
            this.eFormService.statusForm = this.createTaskSignOffComp?.dynamicFormComp.form.status;
         }
      }
   }

   onGetThumbnail(docList) {
      for (let j = 0; j < this.totalPages; j++) {
         this.checkselectedItems[j] = false;
      }
      this.flagCheckSelect = false;
      this.flagCheckSelectInsert = true;
   }

   ngOnDestroy() {
      this.unsubscribeThumbnailReady?.();
   }

   /** สร้างข้อมูล thumbnail ของเอกสารตำแหน่ง i (เรียกซ้ำได้เมื่อไฟล์แปลงเสร็จภายหลัง) */
   private buildThumbnailEntry(data, i) {
      const itemImgThumbnail = [];
      const thumbnailSelected = [];
      this.sendWidthHeighttt2[i] = {itemRotate: [], docId: ''};
      for (let j = 0; j < data[i].totalPages; j++) {
         this.sendWidthHeighttt2[i].itemRotate.push({
            item: {
               scale: 0,
               posx: 0,
               posy: 0,
               transformHeight: 0,
               width: data[i].pages[j].width,
               height: data[i].pages[j].height
            }
         });
         itemImgThumbnail.push({
            docId: data[i].docId,
            pageNo: j + 1,
            isLoad: false,
         });
         thumbnailSelected.push({
            isSelected: false
         });
         this.checkselectedItems[j] = false;
      }
      this.imgThumbnails[i] = {
         itemImgThumbnail: itemImgThumbnail,
         lastPageLoaded: 0,
         thumbnailSelect: thumbnailSelected
      };
      this.sendWidthHeighttt = this.sendWidthHeighttt2[0];
      if (data[i].totalPages > 0) {
         if (this.imgThumbnails[i].itemImgThumbnail.length <= 4) {
            this.setInitialLoadThumbnail(this.imgThumbnails[i].itemImgThumbnail.length, i);
         } else {
            this.setInitialLoadThumbnail(5, i);
         }
         this.createTaskSignOffComp.checkLasyload[i] = this.imgThumbnails[i].lastPageLoaded;
      }
   }

   getThumbnailCreate(docList) { /* change call 1 time and manage data in client */
      this.sendWidthHeighttt2 = [];
      for (let j = 0; j < this.totalPages; j++) {
         this.checkselectedItems[j] = false;
      }
      for (let j = 0; j < this.totalPages; j++) {
         if (j === 0) {
            this.loadedBypage[j] = true;
         } else {
            this.loadedBypage[j] = false;
         }

      }

      this.flagCheckSelect = false;
      this.flagCheckSelectInsert = true;
      this.createTaskSignOffComp.handleWaitAction(true);
      const taskId = this.taskId;
      this.service.transformPdfThumbnails(docList, this.dpi, taskId, true).subscribe((data) => { // เรียกรูป thumbnails
         if (data.length > 0) {
            this.dataPage = data;
            this.imgThumbnails = [];
            this.dataWidthHeight = data[0].pages; // ตั้งค่าความสูงของ page เป็นหน้าแรก
            this.dataWidthHeightAll = data[0].pages; // ตั้งค่าความสูงของ pages ทั้งหมดเป็นหน้าแรก
            this.sendWidthHeighttt2 = [];
            this.totalPages = data[0].totalPages;
            for (let i = 0; i < data.length; i++) {
               this.buildThumbnailEntry(data, i);
            }
            // ไฟล์ที่ยังแปลงไม่เสร็จ: เติม thumbnail ทีละไฟล์เมื่อพร้อม โดยรับผลจาก watcher ของหน้าเอกสาร
            // (เอกสารชุดเดียวกัน จึงไม่ poll ซ้ำเอง ลด request ลงครึ่งหนึ่ง)
            this.unsubscribeThumbnailReady?.();
            this.unsubscribeThumbnailReady = undefined;
            if (data.some(doc => PdfRenditionWatcher.isConverting(doc))) {
               this.unsubscribeThumbnailReady = this.createTaskSignOffComp.renditionWatcher.subscribeReady(doc => {
                  const i = data.findIndex(item => item?.docId === doc.docId);
                  if (this.dataPage !== data || i < 0 || !PdfRenditionWatcher.isConverting(data[i])) {
                     return;
                  }
                  data[i] = doc;
                  this.buildThumbnailEntry(data, i);
                  // ค่าเหล่านี้ใช้กับเอกสารที่เปิดอยู่ (เช่น totalPages <= 2 จะซ่อน scroll ของ thumbnail)
                  // จึงอัปเดตเฉพาะเมื่อไฟล์ที่แปลงเสร็จคือไฟล์ที่เปิดอยู่
                  if (i === this.createTaskSignOffComp.currentIndex) {
                     this.totalPages = doc.totalPages;
                     this.dataWidthHeight = doc.pages;
                     this.dataWidthHeightAll = doc.pages;
                  }
               });
            }
         }
         if (this.createTaskSignOffComp.currentIndex !== 0) {
            if (this.taskAttribute.formName) {
               this.createTaskSignOffComp.currentIndex = 0;
            } else {
               this.createTaskSignOffComp.currentIndex = 0;
               if (this.createTaskSignOffComp.mimType === 'application/pdf'

                  && this.createTaskSignOffComp.leftPanelComp.toolsComp) {
                  this.createTaskSignOffComp.leftPanelComp.toolsComp.selected = 0;
               }
               this.createTaskSignOffComp.changeDrawPage(0); // เรียกการ render หน้าหลังจากที่ load thumbnails เสร็จแล้ว
               // this.imgThumbnails = backup;
            }
         } else {
            this.createTaskSignOffComp.changeDrawPage(this.createTaskSignOffComp.currentIndex); // เรียกการ render หน้าหลังจากที่ load thumbnails เสร็จแล้ว
         }
         this.isThumbnailLoadFinish = true;
         this.handleWaitAction();
         },
         (err) => {
            this.createTaskSignOffComp.handleWaitAction(false);
            this.createTaskSignOffComp.isPageLoadFinish = false;
            this.isThumbnailLoadFinish = false;
            console.error(err);
         });
   }

   flagCheckLoadDataChange() {
      this.createTaskSignOffComp.checkclicklist = true;
   }

   onClickDeleteThumbnail() {
      if (this.selectButton && this.uploadComp.isDocList && this.createTaskSignOffComp.currentIndex === 0) {
         this.handleToastError('newTask.errorSelectDelete');
      } else if (this.selectButton && this.data.typeName === 'startFlow' && this.createTaskSignOffComp.currentIndex === 0) {
         this.handleToastError('newTask.errorSelectDelete');
      } else {
         const dialogRef = this.dialog.open(DeleteDialogComponent, {
            disableClose: true,
            height: '110px',
            data: {
               service: this.service,
               createTaskSignOffComp: this.createTaskSignOffComp,
               taskId: this.taskId,
               toast: this.toast,
               router: this.router,
               selectDelItems: this.selectDelItems,
               totalPages: this.totalPages,
               selectButton: this.selectButton,
               createTaskComp: this
            },

         });
         dialogRef.afterClosed().subscribe(result => {
            if (result.response) {
               this.isDeleteDocument = false;
               for (let j = 0; j < this.totalPages; j++) {
                  this.checkselectedItems[j] = false;
               }
               this.flagCheckSelect = false;
               this.flagCheckSelectInsert = true;
               this.maxIndex = -1;
               this.createTaskSignOffComp.checkclicklist = true;
               this.createTaskSignOffComp.checkheightpage = 0;
               this.onScrollTum(this.createTaskSignOffComp.page);

               this.bindData(result, undefined); // bind data ใหม่หลังจากที่มีการ delete thumbnails
            }
         });
      }
   }

   bindData(result, delIndex) {
      const index = this.createTaskSignOffComp.currentIndex;
      this.onCheckSelectDelItems(delIndex); // รวมหน้าที่ถูก select ว่าลบไว้ใน object arrays thumbnailSelectedDel

      this.indexSelect = this.createTaskSignOffComp.currentIndex; // ตั้งค่าหน้าที่จะลบ data ออก
      this.removePage(this.getImageThumbnail(), this.createTaskSignOffComp.getSelectDataPage(),
         this.createTaskSignOffComp.getSelectTaskDocument(), this.createTaskSignOffComp.itemRotates[index],
         this.createTaskSignOffComp.getItemRotatesNum2(), this.thumbnailSelectedDel); // remove page ออกจาก data หลัก
      if (!result.response.isDeleteTask) { // ถ้าไม่ใข่การ delete task
         if (!result.response.isDeleteDocument) { // ถ้าไม่ใช่การ delete document
            for (const item of this.getThumbnailsSelected()) {
               item.isSelected = false; // reset ค่าที่ select ไว้เป็น unselect ให้หมด
            }
         } else {
            this.isDeleteDocument = true; // ตั้งค่าเป็นการ delete document ทิ้ง กรณีลบทุกหน้า
         }

      } else {
         this.isDeleteDocument = true; // ตั้งค่าเป็นการ delete document ทิ้ง กรณีลบทุกหน้า
      }
      if (this.isDeleteDocument) {
         this.uploadComp.deleteFile(index); // ลบ file นั้นออกจาก doclist ใน taskattribute
         if (index > 0) { // กรณีที่ไม่ได้เลือก document list แรกไว้ ให้ลดค่าลง ตามหน้าปัจจุบันที่เลือก เพื่อให้เลือกหน้าได้ถูกต้อง
            this.createTaskSignOffComp.currentIndex--;
         }
         if (this.taskAttribute.docList.length === 0) { // ถ้า doclist ไม่มีแล้ว ให้ reset มา step แรก
            this.stepper.reset();
            this.imgThumbnails = [];
            this.createTaskSignOffComp.handleWaitAction(false);
         } else {
            this.createTaskSignOffComp.setDocId(this.taskAttribute.docList[this.createTaskSignOffComp.currentIndex].docId);
            this.totalPages = this.createTaskSignOffComp.dataPages[this.createTaskSignOffComp.currentIndex].totalPages;
         }
         this.selectButton = false;
      }
      this.createTaskSignOffComp.refreshPage();
   }

   onCheckSelectDelItems(delIndex) {
      this.thumbnailSelectedDel = [];
      if (delIndex !== undefined) {
         this.thumbnailSelectedDel.push(delIndex + 1);
      } else {
         const thumbnailSelect = this.getThumbnailsSelected();
         for (let i = 0; i < thumbnailSelect.length; i++) {
            if (thumbnailSelect[i].isSelected) {
               this.thumbnailSelectedDel.push(i + 1);
            }
         }
      }
   }

   bindDataInsert(insertPage: number, totalPageInsert: number, dataPages: any[]) {
      const index = this.createTaskSignOffComp.currentIndex;
      this.insertPage(this.getImageThumbnail(), this.createTaskSignOffComp.getSelectDataPage(),
         this.createTaskSignOffComp.getSelectTaskDocument(), this.createTaskSignOffComp.itemRotates[index],
         this.createTaskSignOffComp.getItemRotatesNum2(), insertPage, totalPageInsert, dataPages);
      this.selectButton = false;
      this.createTaskSignOffComp.refreshPage();
   }

   /**
    *
    * @detail : remove thumbnail with client without call getThumbnail again
    * @param imgThumbnails : main object to control Thumbnail componet
    * @param removeValFromIndex : index item select delete thumbnail
    */
   removePage(imgThumbnails, dataPages, taskDocument, itemRotates, itemRotateNum2, removeValFromIndex) {
      let count = 0;
      if (imgThumbnails.itemImgThumbnail.length === removeValFromIndex.length) { // delete all
         this.imgThumbnails.splice(this.createTaskSignOffComp.currentIndex, 1);
         this.createTaskSignOffComp.dataPages.splice(this.createTaskSignOffComp.currentIndex, 1);
         this.createTaskSignOffComp.itemRotates.splice(this.createTaskSignOffComp.currentIndex, 1);
         this.createTaskSignOffComp.itemrotatenum2.splice(this.createTaskSignOffComp.currentIndex, 1);

      } else {
         for (let index = removeValFromIndex.length - 1; index >= 0; index--) {
            this.removeImagePage(dataPages, removeValFromIndex, index);
            this.removeThumbnailPage(imgThumbnails, removeValFromIndex, index);
            this.removeItemRotates(itemRotates, itemRotateNum2, removeValFromIndex, index);
            if (imgThumbnails.lastPageLoaded > 1) {
               imgThumbnails.lastPageLoaded--;
            }
            this.totalPages--;
            count++;
         }
         this.updatePageNo(imgThumbnails, dataPages, removeValFromIndex.length);
         if (imgThumbnails.lastPageLoaded > 0 && imgThumbnails.lastPageLoaded < imgThumbnails.itemImgThumbnail.length) {
            this.updateLoadPageThumbnails(imgThumbnails, imgThumbnails.lastPageLoaded);
         }
      }
   }

   /**
    *
    * @detail : update PageNo After Delete Thumbnails
    */
   updatePageNo(imgThumbnails, dataPages, lenDel) {
      for (let countDel = 0; countDel < lenDel; countDel++) {
         for (let index = 0; index < dataPages.pages.length; index++) {
            if (index === 0) {
               if (imgThumbnails.itemImgThumbnail[index].pageNo - 1 > 0) {
                  const signItemList = this.createTaskSignOffComp.taskAttribute.docList[this.createTaskSignOffComp.currentIndex].signItems;
                  if (signItemList) {
                     const updatePageSignItemSelected = signItemList.filter(signItem => parseInt(signItem.pageNum, 10) === imgThumbnails.itemImgThumbnail[index].pageNo);
                     if (updatePageSignItemSelected) {
                        for (let indexUpdatePageNo = 0; indexUpdatePageNo < updatePageSignItemSelected.length; indexUpdatePageNo++) {
                           updatePageSignItemSelected[indexUpdatePageNo].pageNum -= 1;
                        }
                     }
                  }
                  imgThumbnails.itemImgThumbnail[index].pageNo -= 1;
                  dataPages.pages[index].pageNo -= 1;
               }
            } else {
               if (imgThumbnails.itemImgThumbnail[index].pageNo - 1 > imgThumbnails.itemImgThumbnail[index - 1].pageNo) {
                  const signItemList = this.createTaskSignOffComp.taskAttribute.docList[this.createTaskSignOffComp.currentIndex].signItems;
                  if (signItemList) {
                     const updatePageSignItemSelected = signItemList.filter(signItem => parseInt(signItem.pageNum, 10) === imgThumbnails.itemImgThumbnail[index].pageNo);
                     if (updatePageSignItemSelected) {
                        for (let indexUpdatePageNo = 0; indexUpdatePageNo < updatePageSignItemSelected.length; indexUpdatePageNo++) {
                           updatePageSignItemSelected[indexUpdatePageNo].pageNum -= 1;
                        }
                     }
                  }
                  imgThumbnails.itemImgThumbnail[index].pageNo -= 1;
                  dataPages.pages[index].pageNo -= 1;
               }
            }

         }
      }
   }

   /**
    * @detail : update next page to loading if not load
    */
   updateLoadPageThumbnails(imgThumbnails, pageNo) {
      if (!imgThumbnails.itemImgThumbnail[pageNo].isLoad) {
         imgThumbnails.itemImgThumbnail[pageNo].isLoad = true;
      }
   }

   removeImagePage(dataPages, removeValFromIndex, index) {
      dataPages.maxHeight -= dataPages.pages[removeValFromIndex[index] - 1].height;
      const itemSignTmp = this.createTaskSignOffComp.taskAttribute.docList[this.createTaskSignOffComp.currentIndex].signItems;
      if (itemSignTmp) {
         for (let indexDel = itemSignTmp.length - 1; indexDel >= 0; indexDel--) {
            if (itemSignTmp[indexDel].pageNum.toString() === removeValFromIndex[index].toString()) {
               this.createTaskSignOffComp.taskAttribute.docList[this.createTaskSignOffComp.currentIndex]
                  .signItems.splice(indexDel, 1);
            }
         }
      }

      dataPages.pages.splice(removeValFromIndex[index] - 1, 1);
      dataPages.totalPages -= 1;
   }

   removeThumbnailPage(imgThumbnails, removeValFromIndex, index) {
      imgThumbnails.itemImgThumbnail.splice(removeValFromIndex[index] - 1, 1);
      imgThumbnails.thumbnailSelect.splice(removeValFromIndex[index] - 1, 1);
   }

   removeSignItem(taskDocument, removeValFromIndex, index) {
      let len = taskDocument.signItems.length;
      for (let count = 0; count < len; count++) {
         if (parseInt(taskDocument.signItems[count].pageNum, 10) === removeValFromIndex[index]) {
            taskDocument.signItems.splice(count, 1);
            count--;
            len--;
         }
      }
      taskDocument.totalPages -= 1;
   }

   removeItemRotates(itemRotates, itemRotatesNum2, removeValFromIndex, index) {
      for (let i = removeValFromIndex[index] ; i < itemRotates.itemRotate.length; i++) {
         this.createTaskSignOffComp.itemRotates[this.createTaskSignOffComp.currentIndex].itemRotate[i].item.pageNo -= 1;
      }
      itemRotates.itemRotate.splice(removeValFromIndex[index] - 1, 1);
      itemRotatesNum2.itemRotate.splice(removeValFromIndex[index] - 1, 1);
   }

   insertPage(imgThumbnails, dataPage, taskDocument, itemRotates, itemRotateNum2, insertPageNo, totalPageInsert: number, dataPages: any[]) {
      const index = this.createTaskSignOffComp.currentIndex;
      const docId = this.createTaskSignOffComp.getDocId();
      if (insertPageNo === -1 || insertPageNo === dataPage.pages.length) {
         for (let count = 0; count < totalPageInsert; count++) {
            imgThumbnails.itemImgThumbnail.push({
               docId: docId,
               pageNo: dataPages[count].pageNo,
               isLoad: false,
            });
            imgThumbnails.thumbnailSelect.push({
               isSelected: false,
            });
            this.taskAttribute.docList[index].totalPages++;
            dataPage.totalPages++;
            dataPage.maxHeight += dataPages[count].height;
            if (dataPage.maxWidth < dataPages[count].width) {
               dataPage.maxWidth = dataPages[count].width;
            }
            dataPage.pages.push(dataPages[count]);
            itemRotates.itemRotate.push({
               item: {
                  ...dataPages[count], posx: 0, posy: 0, transformHeight: 0, directRotate: ''
               }
            });
            itemRotateNum2.itemRotate.push({
               item: {
                  ...dataPages[count], posx: 0, posy: 0, transformHeight: 0, directRotate: ''
               }
            });
         }
      } else {
         for (let count = 0; count < totalPageInsert; count++) {
            imgThumbnails.itemImgThumbnail.splice(insertPageNo + count, 0, {
               docId: docId,
               pageNo: dataPages[count].pageNo,
               isLoad: false,
            });
            imgThumbnails.thumbnailSelect.push({
               isSelected: false,
            });
            this.taskAttribute.docList[index].totalPages++;
            dataPage.totalPages++;
            dataPage.maxHeight += dataPages[count].height;
            if (dataPage.maxWidth < dataPages[count].width) {
               dataPage.maxWidth = dataPages[count].width;
            }
            dataPage.pages.splice(insertPageNo + count, 0, dataPages[count]);
            itemRotates.itemRotate.splice(insertPageNo + count, 0, {
               item: {
                  ...dataPages[count], posx: 0, posy: 0, transformHeight: 0, directRotate: ''
               }
            });
            itemRotateNum2.itemRotate.splice(insertPageNo + count, 0, {
               item: {
                  ...dataPages[count], posx: 0, posy: 0, transformHeight: 0, directRotate: ''
               }
            });
         }
         for (let index_sum = insertPageNo + totalPageInsert; index_sum < imgThumbnails.itemImgThumbnail.length; index_sum++) {
            imgThumbnails.itemImgThumbnail[index_sum].pageNo = index_sum + 1;
            dataPage.pages[index_sum].pageNo = index_sum + 1;
            itemRotates.itemRotate[index_sum].item.pageNo = index_sum + 1;
            itemRotateNum2.itemRotate[index_sum].item.pageNo = index_sum + 1;
         }
      }
   }

   /**
    *
    *  ฟังค์ชั่นไว้สำหรับเช็คว่า checkbox ของ page ไหนมีการเลือกไว้บ้างเมื่อกด rotate all และ clearsign เมื่อ page นั้นมีลายเซ็นต์อยู่
    */
   onClickMultiPage() {
      this.selectedItems = [];
      let k = 0;
      for (let i = 0; i < this.totalPages; i++) {
         if (this.checkselectedItems[i] === true) {
            this.selectedItems[k] = i;
            k++;
         }
      }
      const signConflicts = this.createTaskSignOffComp.getSignConflictRotatePage();
      if (signConflicts.length > 0) {
         const dialogRef = this.dialog.open(ConfirmRemovesignDialogComponent, {
            disableClose: true,
         });
         this.translate.get('newTask.confirm').subscribe(s => {
            dialogRef.componentInstance.messageWarning = s;
         });
         dialogRef.afterClosed().subscribe(result => {
            if (result) {
               this.createTaskSignOffComp.clearSignConflict(signConflicts);
               for (const index of this.selectedItems) {
                  this.createTaskSignOffComp.clearSignPage(index + 1, 'right');
               }
               this.service.rotateThumbnailDocument(this.createTaskSignOffComp.getDocId(), 'R', this.selectedItems,
                  this.taskAttribute.taskId)
                  .subscribe((response) => {
                        for (let i = 0; i < this.totalPages; i++) {
                           this.createTaskSignOffComp.itemRotates[this.createTaskSignOffComp.currentIndex].itemRotate[i].item.directRotate = '';
                        }
                        this.createTaskSignOffComp.handleWaitAction(false);
                     },
                     (err) => {
                        console.error(err);
                     });
               this.createTaskSignOffComp.onRotateMulti(this.selectedItems, 'right', k); // recursive
            }
         });
      } else {
         for (const index of this.selectedItems) {
            this.createTaskSignOffComp.clearSignPage(index + 1, 'right');
         }
         this.service.rotateThumbnailDocument(this.createTaskSignOffComp.getDocId(), 'R', this.selectedItems,
            this.taskAttribute.taskId)
            .subscribe((response) => {
                  for (let i = 0; i < this.totalPages; i++) {
                     this.createTaskSignOffComp.itemRotates[this.createTaskSignOffComp.currentIndex].itemRotate[i].item.directRotate = '';
                  }
                  this.createTaskSignOffComp.handleWaitAction(false);
               },
               (err) => {
                  console.error(err);
               });
         this.createTaskSignOffComp.onRotateMulti(this.selectedItems, 'right', k); // recursive
      }
   }

   onSelectFiles($event, input: any) {
      this.createTaskSignOffComp.isClickPage = true;
      this.createTaskSignOffComp.isLoopPage = false;
      if (input.files.length === 0) {
         return;
      }
      const files = input.files;
      this.uploadThumbnail(files);
      this.fileUpload.nativeElement.value = ''; // clear file name after upload
   }

   wrapPage(pageNo) {
      this.createTaskSignOffComp.warpPage(pageNo);
   }

   private init(): Observable<any> {
      return this.service.get('/upload');
   }

   uploadThumbnail(files: any) {
      this.createTaskSignOffComp.zoomOutAndUpdateSign();
      this.createTaskSignOffComp.checkclicklist = true;
      this.createTaskSignOffComp.page = 1;
      this.createTaskSignOffComp.checkheightpage = 0;
      this.createTaskSignOffComp.pageNo1 = 1;
      this.onScrollTum(this.createTaskSignOffComp.page);
      if (this.validateFile(files)) {
         for (let i = 0; i < files.length; i++) {
            this.maxPage = this.ThumbnailComp.checkMaxSelect();
            this.createTaskSignOffComp.handleWaitAction(true);

            files[i].fullPath = files[i].webkitRelativePath;
            const file: any = files[i];
            this.init().subscribe(result => {
               const key = result.key;
               let offset = 0;
               const xhr = new XMLHttpRequest();
               const send = () => {
                  const end = Math.min(offset + this.chunkSize, file.size);
                  xhr.open('PUT', this.service.url + '/upload/' + key, true);
                  xhr.setRequestHeader('x-auth-token', this.service.user.token);
                  xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + file.size);
                  const blob = file.slice.call(file, offset, end);
                  xhr.send(blob);
               };
               xhr.onload = () => {
                  if (xhr.status === 308) {
                     if (file.canceled) {
                        this.service.post('/cancel/upload/' + key, null).subscribe(() => {
                              // This is intentional
                           },
                           (err) => {
                              console.error(err);
                           });
                        return;
                     }
                     offset += this.chunkSize;
                     send();
                  } else if (xhr.status === 201) {
                     this.finish(key, '', file, '', '');
                  }
               };
               send();
            }, error => {
               file.error = error;
            });
         }
      }
   }

   finish(key: string, path: string, file: any, tin: string, id?: string) {
      const body = {
         name: file.fullPath || file.name,
         destination: path,
         mimeType: file.type,
         tin: tin,
         id: id
      };
      this.service.uploadThumbnailDocument(body, this.createTaskSignOffComp.getDocId(),
         this.maxPage, this.createTaskSignOffComp.getMaxPageDocuments(), key, this.taskAttribute.taskId)
         .subscribe((response) => {
               this.toast.success(response.message);
               this.bindDataInsert(this.maxPage, response.totalPageInsert, response.dataPages);
            },
            (err) => {
               this.toast.error(err);
               this.createTaskSignOffComp.handleWaitAction(false);
            });
   }

   validateFile(myFile: any) {
      const $input = $('input[type=file]');
      if (myFile.length > 1) {
         $input.val('');
         $input.attr('title', window.URL ? ' ' : '');
         this.handleToastError('uploadDoc.errorSelectFile');
         return false;
      }

      for (let i = 0; i < myFile.length; i++) {
         if (myFile[i] != null) {
            const ext = myFile[i].type;
            if (ext !== '' && this.validateExtension(ext) === true) {
               if (myFile[i].size > this.service.fileMaxUpload) { // 2097152
                  $input.val('');
                  $input.attr('title', window.URL ? ' ' : '');
                  this.translate.get('uploadDoc.errorFileSize', {size: this.service.getFileMaxUploadMB()}).subscribe(s => this.toast.error(s));
                  return false;
               }
            } else {
               $input.val('');
               $input.attr('title', window.URL ? ' ' : '');
               this.handleToastError('uploadDoc.errorPdf');
               return false;
            }
         }
      }
      return true;
   }

   validateExtension(v) {
      const allowedExtensions = new Array('application/pdf');

      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   sendWidthHeight(select) {
      this.sendWidthHeighttt = select;
   }

   onRotateByPage(index) {
      const page = index + 1;
      const signConflicts = this.createTaskSignOffComp.getSignConflictRotatePage();
      if (signConflicts.length > 0) {
         const dialogRef = this.dialog.open(ConfirmRemovesignDialogComponent, {
            disableClose: true,
         });
         this.translate.get('newTask.confirm').subscribe(s => {
            dialogRef.componentInstance.messageWarning = s;
         });
         dialogRef.afterClosed().subscribe(result => {
            if (result) {
               this.createTaskSignOffComp.clearSignConflict(signConflicts);
               this.ThumbnailComp.flagpage = false;
               this.createTaskSignOffComp.onRotateByPage(index, 'right');
               this.createTaskSignOffComp.clearSignPage(page, 'right');
            }
         });
      } else {
         this.ThumbnailComp.flagpage = false;
         this.createTaskSignOffComp.onRotateByPage(index, 'right');
         this.createTaskSignOffComp.clearSignPage(page, 'right');
      }
   }

   /**
    *
    *  ฟังค์ชั่นไว้สำหรับเช็คว่า checkbox ของ page ไหนมีการเลือกไว้บ้าง
    */
   onCheckSelect(select) {
      let checkInsert = 0;
      this.flagCheckSelect = false;
      if (select.select === -1) {
         for (let j = 0; j < this.totalPages; j++) {
            this.checkselectedItems[j] = true;
         }
      } else if (select.select === -2) {
         for (let i = 0; i < this.totalPages; i++) {
            this.checkselectedItems[i] = false;
         }
      } else {
         this.checkselectedItems[select.select] = select.status;
      }
      for (let k = 0; k < this.totalPages; k++) {
         if (this.checkselectedItems[k] === true) {
            this.flagCheckSelect = true;
            checkInsert++;
         }
      }
      if (checkInsert === 0 || checkInsert === 1) {
         this.flagCheckSelectInsert = true;
      } else {
         this.flagCheckSelectInsert = false;
      }
   }

   flagRotateByPage($event) {
      this.ThumbnailComp.flagpage = true;
   }

   /**
    *
    *  ฟังค์ชั่นไว้เรียก Scroll ฝั่ง thumbnail ให้ขยับตาม
    */
   onScrollTum(page) {
      if (this.isToggleRightOpened) {
         if (this.ThumbnailComp) {
            this.ThumbnailComp.scroll(page);
         }
      }
   }

   toggleRight(): void {

      if (this.info) {
         if (this.info.nativeElement.className.indexOf('slide-right') === -1) {
            this.renderer.addClass(this.info.nativeElement, 'slide-right');
            this.isToggleRightOpened = false;
            if (!this.createTaskSignOffComp.isZoom && this.createTaskSignOffComp._isVisible !== 'visible' && !this.createTaskSignOffComp._isComment) {
               this.createTaskSignOffComp.handleFitPage(true);
            }
            if (this.isToggleLeftOpened) {
               this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T1'));
            } else {
               this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T2'));
            }
         } else {
            this.renderer.removeClass(this.info.nativeElement, 'slide-right');
            this.isToggleRightOpened = true;
            if (!this.createTaskSignOffComp.isZoom && this.createTaskSignOffComp._isVisible !== 'visible' && !this.createTaskSignOffComp._isComment) {
               this.createTaskSignOffComp.handleFitPage(false);
            }
            if (this.isToggleLeftOpened) {
               this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T3'));
            } else {
               this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T4'));
            }
         }
         if (!this.createTaskSignOffComp._isComment) {
            this.createTaskSignOffComp.deselectAll();
         }
         this.createTaskSignOffComp._isComment = false;
         this.createTaskSignOffComp.setLeftComment();
      }
   }

   toggleLeft(): void {
      this.createTaskSignOffComp.drawer.toggle(this.createTaskSignOffComp.navChange(this, this.createTaskSignOffComp.drawer));
      this.isToggleLeftOpened = this.createTaskSignOffComp.drawer.opened;
      if (this.isToggleLeftOpened) {
         if (this.isToggleRightOpened) {
            this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T3'));
         } else {
            this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T1'));
         }
      } else {
         if (this.isToggleRightOpened) {
            this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T4'));
         } else {
            this.createTaskSignOffComp.setHeaderWidth(this.checkWidth('T2'));
         }
      }
      this.createTaskSignOffComp.deselectAll();
      this.createTaskSignOffComp.setLeftComment();
   }

   checkWidth(size) {
      if (size === 'T1' || size === 'T3') {
         return 250;
      } else  {
         return 0;
      }
   }

   loadForm(option: any) {
      this.selectedValue = option;
      this.form = undefined;
      this.service.getType(option.value).subscribe(data => {
            this.form = data;
            this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
         },
         (err) => {
            console.error(err);
         });
   }

   saveType(button: any) {
      const data = {type: this.selectedValue.value, properties: this.getProperties(this.form)};
      if (!data.properties) {
         return;
      }
      button.disabled = true;
      this.translate.get('saving').subscribe(s => {
         this.saveText = s;
      });
      this.service.setSignDocType(this.doc.id, data, this.taskAttribute.taskId).subscribe(value => {
            this.doc.typeName = this.selectedValue.viewValue;
            this.doc.properties = value;
            setTimeout(() => {
               this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, this.doc.properties);
            }, 200);
            this.translate.get('saved').subscribe(s => {
               this.saveText = s;
            });
            setTimeout(() => {
               button.disabled = false;
               this.translate.get('save').subscribe(s => {
                  this.saveText = s;
               });
            }, 5000);
         },
         (err) => {
            console.error(err);
         });
   }

   saveProperties(button: MatButton) {
      const properties = this.getProperties(this.doc.properties);
      if (!properties) {
         return;
      }
      button.disabled = true;
      this.translate.get('create_tasks.saving').subscribe(s => {
         this.saveText = s;
      });
      this.service.setSignDocMetadata(this.doc.id, properties, this.taskAttribute.taskId).subscribe(data => {
            this.doc.properties = data;
            this.translate.get('create_tasks.saved').subscribe(s => {
               this.saveText = s;
            });
            this.trash = true;
            setTimeout(() => {
               button.disabled = false;
               this.translate.get('create_tasks.save').subscribe(s => {
                  this.saveText = s;
               });
            }, 5000);
         },
         (err) => {
            console.error(err);
         });
   }

   private getProperties(form: any[]) {
      const error = function (e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (let i = 0; i < form.length; i++) {
         const f = form[i];
         const e = $('#' + f.name.replace(':', '_'));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + ' is required');
         }
         if (f.constraints && value) {
            if (f.constraints.minLength && value.length < f.constraints.minLength) {
               return error(e, 'Minimum length of ' + f.label + ' is ' + f.constraints.minLength + ' characters');
            }
            if (f.constraints.maxLength && value.length > f.constraints.maxLength) {
               return error(e, 'Maximum length of ' + f.label + ' is ' + f.constraints.maxLength + ' characters');
            }
            if (f.constraints.minValue !== undefined && value < f.constraints.minValue) {
               return error(e, 'Minimum value of ' + f.label + ' is ' + f.constraints.minValue);
            }
            if (f.constraints.maxValue !== undefined && value > f.constraints.maxValue) {
               return error(e, 'Maximum value of ' + f.label + ' is ' + f.constraints.maxValue);
            }
            if (f.constraints.expression && !new RegExp(f.constraints.expression).test(value)) {
               return error(e, 'Value of ' + f.label + ' did not match the pattern');
            }
         }
         properties[f.name] = value;
      }
      return properties;
   }

   saveDescription(e: Event): void {
      const input = <HTMLTextAreaElement>e.target;
      // TODO: call PUT /description { id: this.doc.id, description: input.value }
      this.service.updateDescription(input.value, this.docId)
         .subscribe(
            data => {
               // This is intentional.
            },
            error => {
               console.error(error);
            });

   }

   handleWaitAction() {
      if (this.isThumbnailLoadFinish) {
         if (this.createTaskSignOffComp.isPageLoadFinish || this.createTaskSignOffComp.isFormName) {
            this.createTaskSignOffComp.handleWaitAction(false);
            this.createTaskSignOffComp.isPageLoadFinish = false;
            this.isThumbnailLoadFinish = false;
         }
      }
   }

   /** แสดง ซ่อน loading page */
   handleWaitActionLoadPreview(isShow) {
      if (isShow) {
         $('#pano-sign-task').show();
         $('#preview-sign-task').addClass('blur');
      } else {
         $('#pano-sign-task').hide();
         $('#preview-sign-task').removeClass('blur');
      }
   }

   onClickDownloadAll() {
      this.createTaskSignOffComp.handleWaitAction(true);
      if (this.taskAttribute.docList.length > 0) {
         this.isOnDownloadDoc = true;
         this.createTaskSignOffComp.viewDocumentComp.downloadAll();
         this.createTaskSignOffComp.handleWaitAction(false);
      } else {
         this.handleToastError('menu.errorDownload');
      }
   }

   onClickDownloadCombine() {
      this.createTaskSignOffComp.handleWaitAction(true);
      if (this.taskAttribute.docList.length > 0) {
         this.isOnDownloadDoc = true;
         this.createTaskSignOffComp.viewDocumentComp.downloadCombine('newTask');
         this.createTaskSignOffComp.handleWaitAction(false);
      } else {
         this.handleToastError('menu.errorDownload');
      }
   }

   setEnableDownloadAll() {
      this.isOnDownloadDoc = false;
   }

   /**
    *
    * Method for case Template Page
    */
   getTemplate() {
      if (this.id === 0 || this.id === undefined) {
         this.handleWaitActionLoadPreview(false);
         return;
      }
      this.service.getTemplate(this.id, this.share)
         .subscribe((data) => {
            this.templateInfo = data;
            this.uploadComp.getMimetype(this.templateInfo.docList);
            this.uploadComp.taskAttribute.apvLevel = data.apvLevel;
            if (this.pageType === 'template') {
               this.uploadComp.taskAttribute.taskName = data.templateName;
               this.uploadComp.taskAttribute.docList = data.docList;
            } else {
               this.uploadComp.taskAttribute.templateName = data.templateName; // template name
            }
            this.taskAttribute.workflowId = data.workflowId;
            this.uploadComp.taskAttribute.templateId = data.templateId;

            if (data.siteId) {
               this.uploadComp.taskAttribute.siteId = data.siteId;
               this.uploadComp.selectSiteName = {name: this.uploadComp.getSiteList(data.siteId), tin: data.siteId};
               this.uploadComp.myControlSite.setValue({name: this.uploadComp.getSiteList(data.siteId), tin: data.siteId});
               this.uploadComp.changeSelectSite();
            }

            if(data.link) {
               this.uploadComp.idFolderExport = data.exportFolderId;
               this.uploadComp.link = data.link;
               this.uploadComp.isExport = true;
               this.link = data.link;
               this.idFolderExport = data.idFolderExport;
            }

            if(data.dayLeft && data.dayLeft != 0){
               this.uploadComp.dayLeft = data.dayLeft;
               this.uploadComp.taskAttribute.dayLeft = data.dayLeft;
               this.uploadComp.isSignDate = true;
            }

            if(data.retentionPeriod !== -1){
               this.uploadComp.deletDayleft = data.retentionPeriod;
               this.uploadComp.taskAttribute.retentionPeriod = data.retentionPeriod;
               this.uploadComp.isEndDate = true;
            }

            this.mailFlowComp.flowRecipient.taskAttribute.workflowId = data.workflowId;
            this.mailFlowComp.flowRecipient.flow.getFlowList(data.workflowId);
         }, error => {
            this.errorMessage = error;
         })
         .add(() => {
            this.handleWaitActionLoadPreview(false);
         });
   }

   saveTemplate() {
      if (this.validateSubmit()) {
         if (this.id === null || this.id === undefined) {
            this.id = 0;
         }
         this.createTaskSignOffComp.handleWaitAction(true);
         this.createTaskSignOffComp.deselectAll();
         this.revertDataToNormalSize(this.taskAttribute.docList, this.createTaskSignOffComp.isZoom);
         this.createTaskSignOffComp.setTextContent();
         if (this.uploadComp.link) {
            this.taskAttribute.idFolderExport = this.uploadComp.idFolderExport;
            this.taskAttribute.exportPath = this.uploadComp.link;
         } else {
            this.taskAttribute.idFolderExport = '';
            this.taskAttribute.exportPath = '';
         }
         const getWorkflowId = this.taskAttribute.workflowIdSelect !== 0 ? this.taskAttribute.workflowIdSelect : this.taskAttribute.workflowId;
         this.createTaskSignOffComp.handleWaitAction(false);
         this.service.saveTemplate(this.id, getWorkflowId,this.taskAttribute)
            .subscribe((response) => {
               this.createTaskSignOffComp.handleWaitAction(false);
               this.uploadComp.submitDeleteFile();
               this.toast.success(response);
               this.closePage();
            }, error => {
               this.createTaskSignOffComp.handleWaitAction(false);
               this.errorMessage = error;
            });
      }
   }

   /**
    *
    * @detail : When key down on keyboard 'A' button thumbnails will be selected all button
    * and when key down on keyboard 'D' button thumbnails will be unselected all button.
    */
   @HostListener('document:keydown', ['$event'])
   onKeyDown(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = true;
      } else if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
         if (e.target['id'] === 'textarea_detail') {
            e.preventDefault();
            e.stopPropagation();
            $('#textarea_detail').select();
            $('.textarea_edit').select();
         }
      }
   }

   @HostListener('document:keyup', ['$event'])
   onKeyUp(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = false;
      }
   }

   saveRotate(index) {
      this.createTaskSignOffComp.page = 1;
      this.createTaskSignOffComp.checkheightpage = 0;
      this.createTaskSignOffComp.checkclicklist = true;

   }

   onScrollThumbnails(event) {
      if (this.statechange) {
         this.ThumbnailComp.checkButtonAllRotate2(true, this.imgThumbnails[this.createTaskSignOffComp.currentIndex].lastPageLoaded - 1);
      }
      const lastPageLoaded = this.imgThumbnails[this.createTaskSignOffComp.currentIndex].lastPageLoaded;
      const scrollTop = $(event.target)[0].scrollTop;
      const heightBody = $(event.target)[0].clientHeight;
      const heightChild = $($(event.target)[0]).children()[0].clientHeight;
      const heightChildAll = heightChild * lastPageLoaded;
      if (!this.getThumbnailsSelected()[lastPageLoaded - 1].isSelected) {
         $('.thumbnail_' + (lastPageLoaded - 1)).removeClass('active-thumbnails-height');
         $('.thumbnail_' + (lastPageLoaded - 1)).removeClass('active-thumbnails-width');
      }
      if (Math.ceil((heightBody + scrollTop) + 10) >= heightChildAll) {
         if (this.imgThumbnails[this.createTaskSignOffComp.currentIndex].itemImgThumbnail.length > lastPageLoaded) {
            this.imgThumbnails[this.createTaskSignOffComp.currentIndex].itemImgThumbnail[lastPageLoaded].isLoad = true;
            this.imgThumbnails[this.createTaskSignOffComp.currentIndex].lastPageLoaded++;
            this.createTaskSignOffComp.checkLasyload[this.createTaskSignOffComp.currentIndex]
               = this.imgThumbnails[this.createTaskSignOffComp.currentIndex].lastPageLoaded;
         }
      }
   }

   setInitialLoadThumbnail(num, index) {
      for (let count = 0; count < num; count++) {
         this.imgThumbnails[index].itemImgThumbnail[count].isLoad = true;
      }
      this.imgThumbnails[index].lastPageLoaded = num;
   }

   getDocumentsId() {
      const docIds = [];
      for (const document of this.taskAttribute.docList) {
         docIds.push(document.docId);
      }
      return docIds;
   }

   getImageThumbnail() {
      if (this.imgThumbnails) {
         return this.imgThumbnails[this.createTaskSignOffComp.currentIndex];
      }
      return null;
   }

   getThumbnailsSelected() {
      return this.imgThumbnails[this.createTaskSignOffComp.currentIndex].thumbnailSelect;
   }

   setInitialThumbnail() {
      const index = this.createTaskSignOffComp.currentIndex;
      if (this.imgThumbnails.length > 0) {
         if (this.imgThumbnails[index].itemImgThumbnail !== undefined && this.imgThumbnails[index].itemImgThumbnail.length > 0) {
            this.imgThumbnails[index].itemImgThumbnail = this.imgThumbnails[index].itemImgThumbnail.map((item) => ({
                  ...item,
                  isLoad: false,
               })
            );
            this.imgThumbnails[index].thumbnailSelect = this.imgThumbnails[index].thumbnailSelect.map((item) => ({
                  ...item,
                  isSelected: false,
               })
            );
         }
      }
      // โหลดเริ่มต้นเท่ากับตอนเปิดหน้าครั้งแรก (5 หน้า): เดิม 2 หน้า ไม่เต็มคอลัมน์บนจอใหญ่ จึงไม่มี scroll ให้โหลดหน้าต่อ
      this.setInitialLoadThumbnail(Math.min(5, this.imgThumbnails[index].itemImgThumbnail.length), index);
      this.createTaskSignOffComp.checkLasyload[index] = this.imgThumbnails[index].lastPageLoaded;
   }

   getCountZoom() {
      return this.createTaskSignOffComp.countZoom === 0 ? 1 : this.createTaskSignOffComp.countZoom;
   }

   revertDataToNormalSize(data, checkZoom) {
      if (checkZoom || this.createTaskSignOffComp.countZoom > 0) {
         if (data[this.createTaskSignOffComp.currentIndex].signItems) {
            for (const j of data[this.createTaskSignOffComp.currentIndex].signItems) {
               const index = parseInt(j.pageNum, 10) - 1;
               if (this.createTaskSignOffComp._statusInitial[index].isInitial) {
                  j.fieldWidth /= this.getCountZoom();
                  j.fieldHeight /= this.getCountZoom();
                  j.coordinateX /= this.getCountZoom();
                  j.coordinateY /= this.getCountZoom();
               }
            }
         }
      }
   }

   onCheckloadded(value) {
      this.checkloaded = value;
   }

   onLoadedByPage(value) {
      this.loadedBypage = value;
   }

   onSetNameTask($event: string){
      if($event){
         this.nameSite = " - " + $event;
      }else {
         this.nameSite = "";
      }
   }

   onSetNameCertificate($event){
      if($event) {
         this.certificateHeader = $event;
      }else {
         this.certificateHeader = "";
      }
   }
   getCertificate(){
      this.service.get('cert/list')
      .subscribe((data) => {
         if (data) {
            this.certificateOrgList = data;
         }
      }, error =>{
         this.toast.error(error.massage);
      });
   }
   deleteFileTempAndAnno() {
      if (this.taskAttribute.tempId != null) {
         this.service.deleteDocument(this.taskAttribute.tempId).subscribe(()=> {});
      }
   }
   upNewTemp(taskAttribute, btnBack, btnCancel, btnSave, btnSend) {
      this.service.saveTask(taskAttribute)
         .subscribe((suc) => {
            this.createTaskSignOffComp.handleWaitAction(false);
            this.uploadComp.submitDeleteFile();
            this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false); // enable ปุ่ม
            this.closePage(true);
         },
            (err) => {
               this.createTaskSignOffComp.handleWaitAction(false); // ปิด progress loading
               this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
               console.error(err);
            });
   }

   onSelectFormSigner(data) {
      this.checkSignatureField();
      let setData = {
         stepOrder: data[0].data.signer.stepOrder,
         positionType: 'CT',
         signer: data[0].data.signer.signerEmail,
         pageNum: 1,
         pageType: 'CP',
         fieldType: 'signature-form',
         fieldName: data[0].fieldName,
         color: data[0].data.color
      }
      if (!this.signerData.length && data[0].data.signer.action !== 'clear') {
         this.signerData.push(setData);
      } else {
         let index = this.signerData.findIndex(x => x.fieldName === data[0].fieldName);
         if (data[0].data.signer.action !== 'clear') {
            if (index !== -1) {
               this.signerData[index] = setData;
            } else {
               this.signerData.push(setData);
            }
         } else {
            if (index !== -1) {
               this.signerData.splice(index, 1);
            }
         }
      }
   }

   checkSignatureField() {
      const allSig = [];
      for (let i of this.sections) {
         i.fields.forEach(j => {
            if (!this.eFormService.eForm.value.value[j.fieldName]) {
               this.alreadySign = false
            }
            if (j.fieldType === 'f-signature' && j.required && !this.eFormService.eForm.value.value[j.fieldName]) {
               allSig.push(j);
            }
         });
      }
      this.signatureLength = allSig.length ?? 0;
   }

   setfirstSignField(section: Section[]) {
      this.haveSignField = false;
      section.forEach((sec) => {
         if (sec.fields.find((f) => f.type === 'signature' && f.display)) {
            this.haveSignField = true;
         }
      });
   }

   setToggle(navigate: boolean = true) {
      if (!navigate) { return; }
      const hasChanged = localStorage.getItem('onChanged');
      if (hasChanged) {
         this.handleUnsavedChangesOnExit((canExit: boolean) => {});
      } else {
         this.createTaskSignOffComp.onBackStep(true);
         this.ignoreSelectionChange = true;
         this.stepper.previous();
      }
   }

   handleUnsavedChangesOnExit(callback: (canExit: boolean) => void): void {

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });

      this.translate.get('viewer.confirmTitle').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isSaved = true;
      });

      this.translate.get('viewer.saveInfo').subscribe(s => {
         dialogRef.componentInstance.messageInfo = s;
         dialogRef.componentInstance.isShowInfo = true;
      });

      dialogRef.afterClosed().subscribe(result => {

         if (result) {

            const str = dialogRef.componentInstance.str?.toString();

            if (str === 'ok') {
               localStorage.removeItem('onChanged');
               this.signOffComponent.checkView(
                  this.doc.id,
                  true,
                  () => {
                     this.stepper.previous();
                  }
               );
               callback(true);

            } else {
               localStorage.removeItem('onChanged');
               callback(true);
               this.stepper.previous();
            }

         } else {
            callback(false);
         }
      });
   }

   onCheckSubmit() {
      if ((this.eFormService.formValue.docId || this.eFormService.formValue.id) && this.eFormService.eForm.value) {
         this.submitEForm('view-form');
      }
   }

   submitEForm(actions: string, options?: boolean) {
      this.saveInProgress = true;
      const docId = this.eFormService.formValue.docId === undefined ? '0' : this.eFormService.formValue.docId;
      const formId = this.eFormService.formValue.id === undefined ? 0 : this.eFormService.formValue.id;
      const formInfo = {
         form: this.eFormService.eForm.value,
         tin: localStorage.getItem('tin'),
         formType: 'VF',
         path: localStorage.getItem('form-path'),
         fileName: this.fileFormName
      };

      if (formInfo.form.value && typeof formInfo.form.value === 'object') {
         formInfo.form.value = JSON.stringify(formInfo.form.value);
      }

      this.api.submitEForm(actions, formId, formInfo, docId).subscribe((res) => {
            this.closePage();
            if (actions === 'new-form' || actions === 'view-form' || options) {
               this.saveInProgress = false;
            } else {
               const _transformDate = new MomentPipe();
               this.eFormService.formValue.id = res.formId;
               this.eFormService.formValue.lastUpdate = {when: _transformDate.transform(res.lastUpdate)};
               this.eFormService.formValue.version = res.version;
               this.eFormService.eForm.markAllAsTouched();
            }
         }, (err) => {
            this.createTaskSignOffComp.handleWaitAction(false);
            this.saveInProgress = false;
            this.toast.error(err.message)
         },
         () => {
            this.createTaskSignOffComp.handleWaitAction(false);
            this.saveInProgress = false;
            this.eFormService.unInitailization();
         });
   }

   onShowDownloadAll(isShowDownloadAll: boolean) {
      this.isShowDownloadAll = isShowDownloadAll;
   }

   updateSignValid(signerList) {
      if (signerList.length) {
         setTimeout(() => {
            this.createTaskSignOffComp.validateForm(signerList, true);
         }, 10);
      }
   }

   initStep3() {
      this.eFormService.changeFlowRecipientData.next(true);
   }

   eformSubmitPayload() {
      const docId = this.eFormService.formValue.docId === undefined ? '0' : this.eFormService.formValue.docId;
      const formId = this.eFormService.formValue.id === undefined ? 0 : this.eFormService.formValue.id;

      const formInfo = {
         form: this.eFormService.eForm.value,
         tin: localStorage.getItem('tin'),
         formType: 'VF',
         path: localStorage.getItem('form-path'),
         fileName: this.fileFormName ? this.fileFormName : localStorage.getItem("filename")
      };

      if (formInfo.form.value && typeof formInfo.form.value === 'object') {
         formInfo.form.value = JSON.stringify(formInfo.form.value);
      }

      const payload = {
         docId: docId,
         formId: formId,
         formInfo: formInfo,
         actions: 'view-form'
      }

      return payload;
   }

   checkEFormValid() {
      if (this.createTaskSignOffComp?.dynamicFormComp?.form.status) {
         if (this.createTaskSignOffComp?.dynamicFormComp.form.status.toLowerCase() === 'valid') {
            return true;
         } else {
            return false
         }
      } else {
         if (this.eFormService.statusForm && this.eFormService.statusForm.toLowerCase() === 'valid') {
            return true;
         } else {
            return false
         }
      }
   }
}
